export default {
    carousel:{
        prev:'',
        next:'',
        ariaLabel:{
            delimiter: ''
        }
    },
    login:{
        accountLogin:'Account login',
        codeLogin:'Valid code login',
        accountOrPhone:'Account/PhoneNumber',
        password:'Password',
        NowLogin:'Login',
        pLogin:'Account can log in all products for company',
        areaCode:'AreaCode',
        phoneNumber:'PhoneNumber',
        validCode:'Valid Code',
        getCode:'Get Code',
        resend:'Resend',
        forgetPasswd:'Forget Password',
        forgetPasswdMarginLeft:'3.2rem',
        freeRegister:'Free Registration',
        AccountNoEmpty:' Not Empty',
        passWdNoEmpty:' Not Empty',
        NoEmpty:'Not Empty',
        phoneError:'PhoneNumber Error',
        phoneError1:'Phone Must Be 0-9',
        error1:'Account/Password Error',
        error2:'Phone/Code Error',
        error3:'Account/Phone No Register',
        error4:'Network Error',
        error5:'Phone No Register',
        error6:'Phone Error',
        error7:'Phone NoEmpty',
    },
    register:{
        register:'Register',
        regNewAccount:'Register New Account',
        haveSoCreate:'Have it, Login Now ',
        account:'Account',
        accountExplain:'Both Chinese and English,up to 14  characters',
        setPassword:'Password',
        passwordExplain:'Use letters, numbers and symbols, 8-20 characters.',
        phoneNumber: 'Phone',
        validCode:'ValidCode',
        getCode:'Get Code',
        resend:'Resend',
        read:'Agreed to company',
        read1:'UsersRegistrationAgreement',
        read2:'View Sgreement',
        read3:'and',
        read4:'PrivacyStatement',
        read5:'View Privacy Statement',
        info:'Company account is common to all products in the portal, you can use this account to log in all products under the portal.',
        regSuccess:'Your account has been registered successfully',
        regSuccess1:'s you will be redirected to the landing page.',
        LoginNow:'Login',
        rules1:'Not Empty',
        rules2:'Cannot exceed 14 characters in length',
        rules3:'Password length cannot be less than 8',
        rules4:'Password length cannot exceed 20',
        rules5:'Error PhoneNumber',
        rules6:'Password contains spaces',
        rule7: 'Mailbox format error' ,
        rules8: 'User name registered',
        rules9: 'Network Error',
        rules10: 'Mobile number registered',
        email: 'Email',
        prefix: 'prefix',
    },
    changePassword:{
        accountSet:'Account Setting',
        changePassword:'Change Password',
        haveSoCreate:'Have it, Login Now',
        inputOldPasswd:'Old Passwd',
        inputNewPasswd:'New Passwd',
        forgetPasswd:'Forget Passwd',
        passwordExplain:'Use letters, numbers and symbols, 8-20 characters.',
        sure:'Change',
        info:'Company account is common to all products in the portal, you can use this account to log in all products under the portal.',
        regSuccess:'Your password has been set successfully',
        regSuccess1:'s you will be redirected to the landing page.',
        LoginNow:'Login',
        rules1:'Not Empty',
        rules2:'Cannot exceed 14 characters in length',
        rules3:'Password length cannot be less than 8',
        rules4:'Password length cannot exceed 20',
        rules5:'Error PhoneNumber',
        rules6:'Password contains spaces',
    },
    forgetPassword:{
        accountSet:'Account Setting',
        findPassword:'Find Password',
        haveSoCreate:'Have it, Login Now',
        phoneNumber: 'Phone',
        findExplain:' Phone no register, contact',
        people:'Artificial customer service',
        validCode:'ValidCode',
        getCode:'Get Code',
        resend:'Resend',
        setPassword:'Password',
        passwordExplain:'Use letters, numbers and symbols, 8-20 characters.',
        sure:'Confirm',
        info:'Company account is common to all products in the portal, you can use this account to log in all products under the portal.',
        regSuccess:'Your password has been set successfully',
        regSuccess1:'s you will be redirected to the landing page.',
        LoginNow:'Login',
        callUs:'Contact us',
        market:'market',
        phone:'phone',
        company:'Changguang Satellite Technology Co., Ltd',
        close:'Close',
        rules1:'Not Empty',
        rules2:'Cannot exceed 14 characters in length',
        rules3:'Password length cannot be less than 8',
        rules4:'Password length cannot exceed 20',
        rules5:'Error PhoneNumber',
        rules6:'Password contains spaces',
        rules7:'Mobile number not registered',
        rules8:'Mobile number cannot be empty',
        rules9: 'Wrong verification code or mobile number',
    },
    homeFooter:{
        tel:'Telephone',
        email:'Email',
        advisoryService: 'Advisory',
        weChat:'WeChat public number',
        blog:'Official micro-blog',

        startToExperience:'START',
        archivedData:'Archive',
        programmedPhotography:'Tasking',
        yjs:'Visualization Platform',
        sampleData:'Sample Data',
        constellationPerformanceSimulation:'Satellites Simulation',
        globalTargetLibrary:'Global Target Library',

        productsAndServices:'PRODUCTS',
        satelliteImage:'Satellite Image',
        valueAddedProducts:'Value-added Products',
        applicationPlatform:'Application Platform',
        toolSoftware:'Tool Software',
        satelliteConstellationPage:'Satellite Constellation Page',

        userSupport:'SUPPORT',
        resourceCenter:'Resource Center',
        pricing:'Pricing Rules',
        developers:'Developers Support',

        developer: 'Developers',

        companyName:'CHANG GUANG SATELLITE TECHNOLOGY CO.,LTD.',
        ICP:'ICP 15001825 -1',
        address:'1299 mingxi road, beihu science and technology development zone, changchun city, jilin province, China',

    },
    homeNavi:{
        title:"MALL",
        homePage:'Home',
        login:'Login',
        register:'Registered',
        personalCenter:'Personal Center',
        myOrder:'My Order',
        logout:'Logout',

        startToExperience:'START',
        productsAndServices:'PRODUCTS',
        userSupport:'SUPPORT',
        archivedDataOrder:'ARCHIVE',
        programmedPhotography2:'TASKING',
        aboutUs:"ABOUT",

        archivedData:'Archive',
        programmedPhotography:'Tasking',
        yjs:'Visualization Platform',
        sampleData:'Sample Data',
        constellationPerformanceSimulation:'Satellites Simulation',
        constellationVisibilityAnalysis:'Satellites Visibility Analysis',
        globalTargetLibrary:'Global Target Library',

        satelliteImage:'ARCHIVE',
        ordinaryOpticalImage:"Ordinary Optical Image",
        luminousImages:"Luminous Image",
        multispectralImage:"Multispectral Image",
        satelliteVideo:'Satellite Video',
        threeDData:'3D Data',

        valueAddedProducts:'SOLUTIONS',
        remoteSensingData:'Remote Sensing Data Set',
        onePicture:'One Image',
        urban:'Urban',
        agriculturalRemoteSensing:'Agricultural',
        forestryRemoteSensing:'Forestry Remote',
        waterConservancyRemoteSensing:'Water',
        ecoEnvironmentalRemoteSensing:'Eco-environmental',

        applicationPlatform:'APPLICATIONS',
        dataAccessSystem:'Jilin-1 Data Access System',
        visualizationPlatform:'3D Visualization Platform',
        twoViolations:'"Two Violations" Remediation Remote Sensing Supervision Service System',
        agriculturalInsuranceServiceSystem:'Agricultural Insurance Remote Sensing Service System',
        skyAndGroundMonitoringSystem:'Integrated Sky And Ground Monitoring System In Nature Reserves',
        riverMasterInformationManagementSystem:'River Master Information Management System',
        ecologicalProtectionRedLineSystem:'Ecological Protection Red Line Remote Sensing Application System',
        satelliteConstellationPlanningSystem:'Remote Sensing Satellite Constellation Planning System',

        toolSoftware:'TOOLS',
        fastProcessingAllInOneMachine:'Remote Sensing Data Fast Processing All-in-one Machine',
        satellitePlanningSystem:'Satellite Planning System',
        spectralImageProcessing:'Spectral Satellite Image Processing Suite',
        globalTargetLibrarySoftware:'Jilin-1 Global Target Library Software',
        videoProcessing:'Satellite Video Processing Suite',

        satelliteConstellationPage:'SATELLITES',
        satelliteConstellationPage1:'Jilin No.1 constellation',
        resourceCenter:'RESOURCES',
        sampleData2:'Sample Data',
        documentMaterial:'Document Material',
        toolSoftware2:'Tools & Software',
        ADailyChart:'Daily Image',

        pricing:'PRICING RULES',
        pricing1: 'Pricing Rules',

        developers:'DEVELOPERS SUPPORT',
        APIService:'API Service',

        chromeAlert:'For a better experience, it is recommended to use the Chrome browser to visit this site',
        chromeAlertDownload:'download',
        chromeAlertClose:'close',


    },
    water:{
        title:'Water Conservancy Remote Sensing Application',
        titleText:'With the growth of economy, the increase of population and the change of environment, the problem of water resources is gradually prominent. In view of the current situation of water resources in China, remote sensing technology is introduced on the basis of traditional survey, planning and management technology to accelerate the acquisition and update of information and promote the development of water conservancy industry.',
        acquiringSolutions:'Acquiring Solutions',

        title2:'Remote Sensing Big Data Promotes The Construction Of Water Conservancy Informatization',
        titleText2:'With the development and utilization of water resources in China becoming increasingly severe, the implementation of the most stringent water resources management and water conservancy fine management has put forward higher requirements for water conservancy informatization. The massive remote sensing data of "jilin no. 1" provide strong technical support and guarantee for the development of water conservancy services, such as flood control and drought relief, rational allocation of water resources, protection of water ecological environment, construction, management and service of water conservancy projects.',

        surfaceWaterResourceMonitoring:'Surface Water Resource Monitoring',
        surfaceWaterResourceMonitoringImgPs:'Extraction of surface water resources in suzhou city, jiangsu province, 2018-2019',
        surfaceWaterResourceMonitoringText:'Based on the spectral information of remote sensing data, the surface water body recognition model is established, and the discontinuous extraction of surface rivers is solved by combining with the deep learning algorithm, which provides data support for the investigation of surface water resources and the monitoring of water ecological environment.',
        surfaceWaterResourceMonitoringItem1:'To obtain the area of surface water and the location of water boundary',
        surfaceWaterResourceMonitoringItem2:'Multi-phase dynamic monitoring to obtain water change information',

        waterQualityMonitoring:'Water Quality Monitoring',
        waterQualityMonitoringImgPs:'Water quality monitoring in suzhou, jiangsu province, 2018-2019',
        waterQualityMonitoringText:'By monitoring the parameters such as chlorophyll a and suspended solids in water by the image of "jilin no. 1" spectral star and identifying the black and smelly water, it can provide a foundation for urban water environmental protection and water pollution control.',
        waterQualityMonitoringItem1:'To estimate the concentrations of chlorophyll a and suspended solids in large lakes, reservoirs, rivers and estuaries',
        waterQualityMonitoringItem2:'To obtain the distribution of urban black and smelly water bodies',

        lakeShorelinesMonitoring:'Lakes Shoreline Monitoring',
        lakeShorelinesMonitoringImgPs:'Ecological monitoring around drinking water sources of hekou reservoir from 2015 to 2017',
        lakeShorelinesMonitoringText:'In combination with the function positioning of water environment in river reach, a certain width of river and lakeside protection blue line is demarcated. The high-resolution remote sensing image of "jilin no. 1" is used to monitor the illegal buildings and structures that have been built or are under construction within the ecological blue line but have not been approved by the planning, have not been built according to the approval plan, and have not been dismantled within the time limit of the approval, so as to provide a basis for the demolition and renovation of illegal buildings.',
        lakeShorelinesMonitoringItem1:'Provides advanced imaging products within the blue line range of riparian conservation',
        lakeShorelinesMonitoringItem2:'Extraction of illegal buildings within the blue line of riparian ecological protection to provide spatial distribution products of illegal buildings',
        lakeShorelinesMonitoringItem3:'Provide monitoring and analysis report of illegal building',

        floodDisasterMonitoring:'Flood Disaster Monitoring',
        floodDisasterMonitoringImgPs:'Before and after the devastating flood in wuhan in 2016',
        floodDisasterMonitoringText:'Based on the analysis of the relationship between spectral characteristics and spatial position of flood, the fast extraction of flood inundation range is realized.To provide scientific and effective monitoring and assessment results of flood and waterlogging disasters, as an important basis for decision-making of disaster prevention and reduction, and to improve the timeliness and accuracy of decision-making and assessment of flood and waterlogging disasters.',
        floodDisasterMonitoringItem1:'Advanced imaging products for disaster area emergency response and disaster continuous monitoring',
        floodDisasterMonitoringItem2:'Disaster information extraction and evaluation, rapid extraction of flooded area area, identification accuracy is not less than 80%',
        floodDisasterMonitoringItem3:'Provide monitoring and analysis report based on disaster identification and dynamic analysis results',

        slogan:'Jilin-1 is committed to providing you with better remote sensing services',


    },
    savedProduct:{
        title:'Archive Image',
        titleText:'With the successful launch of the gaofen-02b satellite, a new construction process has begun for the jilin no. 1 constellation. The jilin-1 constellation already has 16 satellites in orbit, capable of revisiting anywhere in the world up to six times a day. At the same time, the coverage capacity of the constellation sub-meters has been improved again, which can add 800,000 square kilometers of domestic coverage and 3 million square kilometers of overseas coverage in a single day, further improving the overall service level of the "jilin no. 1" constellation.',

        archivedImage:'Mass Archive Data',
        archivedImageText:'The "Jilin-1" constellation has 16 satellites in orbit, all operated by ChangGuang Satellite Technology CO.,LTD. It can visit any position in the world up to 6 times in a day, and can observe more than 200 targets in a day.It has carried out more than 20,000 shooting missions, covering an area of more than 50 million square kilometers, and provided a variety of remote sensing information services for more than 100 units in more than 10 countries.',
        archivedImageItem1:'Multiple Imaging Modes',
        archivedImageItem1Ps:'general optics, noctilucent, staring video, multispectral, stereo, and space objects',
        archivedImageItem2:'Multiple Spatial Resolutions',
        archivedImageItem3:'Multiple Spectral Combinations',
        spectrum:'spectrum',

        sampleData:'Sample Data',
        ordinaryOpticalImage:'Ordinary Optical Image',
        luminousImages:'Luminous Image',
        satelliteVideo:'Satellite Video',
        multispectralImage:'Multispectral Image',
        threeDData:'3D Image',
        SpaceTargetImaging:'Space Target Imaging',

        getMoreData:'Get More Data',

        L1Product:'L1-Grade Product Specifications',
        GXAImage:"GXA Image",
        SP03Video:"SP03 Video",
        SP0408Video:'SP04-08 Video',
        SP0408Image:'SP04-08 Image',
        GPImage:'GP Image',
        GF03AImage:'GF03A Image',
        GF02ABImage:'GF02A&GF02B Image',
        KF01Image:'KF01 Image',

        technicalIndicators:'Technical Indicators',
        parameters:'Parameters',
        resolution:'Resolution',
        spectralSegment:'Spectral Segment',
        quantizationBits:'Quantization Bits',
        standardImageSize:'Size of Standard View',
        trackHeight:'Track Height',
        locationPrecision:'Location Precision Without Ground Reference Points',
        panchromatic:'Panchromatic Colour',
        multispectral:'Multispectral',
        fullColour:'Full Colour',
        blue:'Blue',
        green:'Green',
        red:'Red',
        nearInfrared:'Near-infrared',
        redEdge:'Red-edge',
        multispectralSpectrum:'Multispectral spectrum',
        shortWaveInfraredSpectrum:'Short-wave infrared spectrum',
        mediumWaveInfraredSpectrum:'Medium-wave infrared spectrum',
        longWaveInfraredSpectrum:'Long-wave infrared spectrum',
        sixPointCameraMode:'6 point camera mode, default',
        threePointCameraMode:'3 point camera mode',

        checkProductDescription:'Check the full version of the standard product description',


    },
    remoteSensing:{
        title:'Remote Sensing Data Set',
        titleText1:'A large number of sub-meter high resolution optical remote sensing images obtained from "jilin no. 1" constellation',
        titleText2:'It contains more than ten categories and millions of pieces of data, and can be customized according to customer requirements.',
        dataCubeText:'With the rapid development of artificial intelligence and the advent of data-driven AI era, the lack of data has always been the fundamental problem that restricts the study of models. Because of its characteristics of scale diversity, special perspective and high background complexity, remote sensing image requires special remote sensing image data set for the task of remote sensing target detection. Jilin-1 remote sensing image data set, composed of sub-meter high-resolution optical remote sensing images, contains more than 10 categories and millions of data, and can be customized according to customer demand.',
        dataSetShow:'Data Set Show',
        airport:'Airport',
        port:'Port',
        tank:'Tank',
        miningArea:'Mining Area',
        ship:'Ship',
        plane:'Plane',
        stadium:'Stadium',
        powerStations:'Power Station',
        customizeThematicDataset:'Customize Thematic Dataset',
        experienceImmediately:'Experience Immediately',
        contactUs:'Contact Us',
        market: 'market',
        phone: 'phone',
        company: 'Chang Guang Satellite',
        close: 'Close',
    },
    material:{
        title:'Download Center',
        titleText:'Download center open satellite data product materials, user manuals and tools, so that the use process is simple and efficient.',

        title2:'Chang Guang Satellite Technology Co., Ltd. Download Center',
        title2Text:'Chang Guang Satellite Technology Co., Ltd. Download center provides satellite data product materials, user manuals and related tools for developers, data agents and integrators, These documents fully explain the satellite product standards and other relevant information, making the use process simple and efficient.',

        download:'Download',
        checkDownload:'Check Download',

        noDataAboutSearch1:"Can't find the data about ",
        noDataAboutSearch2:'',

    },
    sampleData:{
        searchPlaceholder:'Search',
        mostSearchKeyword:'Most searched keywords',

        expand:'Expand',
        collapse:'Collapse',

        scenario:'Scenario',
        processing:'Processing',
        type:'Type',
        satellite:'Satellite',
        resolution:'Resolution',

        dataList:'Data List',
        parameters:'Parameters',
        dataNum1:'There are',
        dataNum2:'data',

        download:'Download',
        dataSize:'Size',
        dataUpdate:'Update ',
        noResult:"I'm sorry, the search result you requested was not found",
        loadingData:'Click or drop down to load the data',
        loadingFinish:'Exactly',


        GXAImage:"GXA Image",
        SP03Video:"SP03 Video",
        SP0408Video:'SP04-08 Video',
        SP0408Image:'SP04-08 Image',
        GPImage:'GP01/02 Image',
        GF03AImage:'GF03A Image',
        GF02ABImage:'GF02A/02B Image',
        KF01Image:'KF01A Image',

        L1Product:'L1-Grade Product Specifications',
        technicalIndicators:'Technical Indicators',
        parameters2:'Parameters',
        resolution2:'Resolution',
        spectralSegment:'Spectral Segment',
        quantizationBits:'Quantization Bits',
        standardImageSize:'Size of Standard View',
        trackHeight:'Track Height',
        locationPrecision:'Location Precision Without Ground Reference Points',
        panchromatic:'Panchromatic Colour',
        multispectral:'Multispectral',
        fullColour:'Full Colour',
        blue:'Blue',
        green:'Green',
        red:'Red',
        nearInfrared:'Near-infrared',
        redEdge:'Red-edge',
        multispectralSpectrum:'Multispectral spectrum',
        shortWaveInfraredSpectrum:'Short-wave infrared spectrum',
        mediumWaveInfraredSpectrum:'Medium-wave infrared spectrum',
        longWaveInfraredSpectrum:'Long-wave infrared spectrum',
        sixPointCameraMode:'6 point camera mode, default',
        threePointCameraMode:'3 point camera mode',

        checkAllParameters:'Click to check all parameters',

        close:'Close',


    },
    common:{
        getSolution:'Get solutions',
        ending:'“Jilin-1” dedicated to Providing You with Good Remote Sensing Services',
        contactUs:'Contact us',
        market:'Market:',
        tel:'Tel:',
        us:'Chang Guang Satellite',
        close:'Close',
        goNow:'Go now',
        buyNow:'Buy now',
        seeMore:'See more',
    },
    API: {
        judeDiv:'Summary',
        title: 'Chang Guang Satellite Service API',
        title_: 'CG Satellite Service API',
        latestUpdateTime: 'Last updated: August 19, 2019：',
        summary:'Summary',
        summary1:'The login interface provides the function of user obtaining token and authenticating user access rights. All interface calls need to provide the token obtained after the user logs in. By default, the default effective time limit for obtaining the token through the login interface is 7 days. If you need a continuously available user token, please contact Changguang satellite marketing department to obtain it. When a service interface is called, a 700 error is returned if the token expires or the permission is insufficient. The interface verifies the user name and password through HTTP protocol, and returns the user token after verification.',
        summary2:'According to the space, time, data type, data index and other information specified by the user, query the standard product archive database of Changguang satellite, and return the qualified data list for the user.',
        summary3:'Returns archive data statistics under specified conditions.',
        summary4:'Query archive data statistics up to now.',
        summary5:'Through this interface, users can query the satellite transit time points in the input time period.',
        summary6:'Users can submit the requirements of programming photography through this interface.',
        requestURL:'Request URL',
        requestMethod:'Request method',
        requestField:'Request field parameter description',
        requestFieldContinued:'Request field parameters continued',
        responseField:'Response field description',
        returnResultExample:'Return result example',
        introduction: 'Chang Guang satellite service API provides developers, Chang Guang satellite data agents and integrators with HTTP interfaces to support users to use Chang Guang satellite standard product access services online in the way of interface call. Before using the service, users need to contact Chang Guang satellite marketing department to apply for API key, and different types of users can obtain different data access and access capabilities.',
        interfaceList: 'List of interface',
        apiList1:'Verify Key',
        apiList2:'Coverage area query interface',
        apiList3:'Archive data information statistics interface',
        apiList4:'Programming photography submission interface',
        apiList5:'Demand status acquisition interface',
        apiList6:'Satellite transit query interface',
        interfaceListItem1: 'Verify Key',
        interfaceListItem2: 'Coverage area query interface',
        interfaceListItem3: 'Archive data information statistics interface',
        interfaceListItem4: 'Programming photography submission interface',
        interfaceListItem5: 'Demand status acquisition interface',
        interfaceListItem6: 'Satellite transit query interface',
        returnRule: 'Regulation return value',
        returnSample:
            '{\n' +
            '    "data": xxxxxxx,                            return data\n' +
            '    "message": xxxxxxx,                     status code ，see 2.4 for details\n' +
            '    "status": xxxxxxx                           status description，see 2.4 for details\n' +
            '}',
        returnIllustrateList: 'Return value description',
        returnListHeaders1: 'status code',
        returnListHeaders2: 'status description',
        returnListHeaders3: 'include error description',
        returnDescriptionListStatus00: 'null',
        returnDescriptionListStatus1: 'success',
        returnDescriptionListStatus2: 'server internal error',
        returnDescriptionListStatus3: 'illegal parameter',
        returnDescriptionListStatus4: 'method returned null',
        returnDescriptionListStatus5: 'add failed',
        returnDescriptionListStatus6: 'failed to update data',
        returnDescriptionListStatus7: 'failed to delete data',
        returnDescriptionListStatus8: 'wrong parameters',
        returnDescriptionListStatus81: 'parameter format error or out of range or input error',
        returnDescriptionListStatus9: 'account problems',
        returnDescriptionListStatus91: 'no such user, account is frozen, password is wrong, the user has been registered',
        returnDescriptionListStatus10: 'token exception',
        returnDescriptionListStatus101: 'token expired or validation failed',
        itemsTitle1:'Summary',
        itemsTitle2:'Verify Key',
        items11:'Archive query API',
        items12:'Standard data abbreviation information query',
        items13:'Coverage area query interface',
        items14:'Archive data information statistics interface',
        items21:'Programming photography API',
        items22:'Programming photography submission interface',
        items31:'Satellite visibility API',
        items32:'Satellite transit query interface',
        KeyrequestParamHeaders1:'Name',
        KeyrequestParamHeaders2:'Description',
        KeyrequestParamHeaders3:'Type',
        KeyrequestParamHeaders4:'Required',
        KeyrequestParamHeaders5:'Remarks',
        KeyrequestParamList1:'account',
        KeyrequestParamList2:'password',
        KeyresponseParamHeaders1:'Number',
        KeyresponseParamHeaders2:'Name',
        KeyresponseParamHeaders3:'Description',
        KeyresponseParamHeaders4:'Type',
        KeyresponseParamHeaders5:'Remarks',
        KeyresponseParamList41:'token obtained by user',
        KeyresponseParamList42:'it is carried to the header of the subsequent request to prove whether it has permission to access the resource',
        productInforequestParamHeaders1:'Name',
        productInforequestParamHeaders2:'Description',
        productInforequestParamHeaders3:'Type',
        productInforequestParamHeaders4:'Required',
        productInforequestParamHeaders5:'Remarks',
        productInforequestParamList11:'pageSize',
        productInforequestParamList12:'pageSize=0,pageNum=0:no paging',
        productInforequestParamList21:'request page',
        productInforequestParamList22:'pageSize=0,pageNum=0:no paging',
        productInforequestParamList31:'fields sorted by',
        productInforequestParamList32:'orderByField not null;optional sort fields include imagingTime,imageGsd',
        productInforequestParamList41:'sort order',
        productInforequestParamList42:'order=asc ascending order,order= desc descending order orderByField is null，do not sort by default',
        productInforequestParamList51:'product type',
        productInforequestParamList52:'single choice, see the table below for details',
        productInforequestParamList61:'data spectrum',
        productInforequestParamList62:'multiple choice, see the table below for details',
        productInforequestParamList71:'resolution',
        productInforequestParamList72:'single choice, see the table below for details',
        productInforequestParamList81:'cloud cover',
        productInforequestParamList82:'0-99 optional, default value is 50, query data no higher than this value',
        productInforequestParamList91:'sidesway angle',
        productInforequestParamList92:'0-45 optional, default value 45, query data no higher than this value',
        productInforequestParamList101:'shooting start time',
        productInforequestParamList102:'one time is allowed to be empty',
        productInforequestParamList111:'shooting end time',
        productInforequestParamList112:'one time is allowed to be empty',
        productInforequestParamList121:'product quality',
        productInforequestParamList122:'make one choice from A,B,C,D',
        productInforequestParamList131:'geographical scope of query area',
        productInforequestParamList132:'geojson format',
        productInforequestParamList1_11:'1:General optical image',
        productInforequestParamList1_12:'JL101A-Jilin-1GXA\n' +
            'JL104B-Jilin-1SP04\n' +
            'JL105B-Jilin-1SP05\n' +
            'JL106B-Jilin-1SP06\n' +
            'JL107B-Jilin-1SP07\n' +
            'JL108B-Jilin-1SP08',
        productInforequestParamList1_21:'2:Luminous image',
        productInforequestParamList1_22:'JL103B-Jilin-1SP03\n' +
            'JL104B-Jilin-1SP04\n' +
            'JL105B-Jilin-1SP05\n' +
            'JL106B-Jilin-1SP06\n' +
            'JL107B-Jilin-1SP07\n' +
            'JL108B-Jilin-1SP08',
        productInforequestParamList1_31:'3:Video image',
        productInforequestParamList1_32:'JL103B-Jilin-1SP03\n' +
            'JL104B-Jilin-1SP04\n' +
            'JL105B-Jilin-1SP05\n' +
            'JL106B-Jilin-1SP06\n' +
            'JL107B-Jilin-1SP07\n' +
            'JL108B-Jilin-1SP08',
        productInforequestParamList1_41:'4:Multispectral image',
        productInforequestParamList1_42:'PMS\n' +
            'LWIR long wave infrared\n' +
            'MWIR middle wave infrared\n' +
            'SWIR short wave infrared',
        productInforequestParamList1_43:'JL101C-Jilin-1GP01\n' +
            'JL102C-Jilin-1GP02',
        productInforesponseParamList31:'data list',
        productInforesponseParamList311:'product id',
        productInforesponseParamList312:'satellite',
        productInforesponseParamList313:'resolution',
        productInforesponseParamList314:'shoot time',
        productInforesponseParamList315:'geographic scope information',
        productInforesponseParamList316:'count of spectral bands',
        productInforesponseParamList317:'included spectrum bands',
        productInforesponseParamList318:'cloud cover',
        productInforesponseParamList319:'sidesway angle',
        productInforesponseParamList3110:'thumbnail',
        productInforesponseParamList3111:'thumb chart',
        productInforesponseParamList3112:'product quality',
        productInforesponseParamList3113:'product type',
        productInforesponseParamList3114:'solar altitude angle',
        productInforesponseParamList3115:'landscape center longitude',
        productInforesponseParamList3116:'landscape center latitude',
        productInforesponseParamList3117:'sensor',
        productInforesponseParamList3118:'Product spectral band',
        productInforesponseParamList32:'total number',
        productInforesponseParamList33:'total page number',
        productInforesponseParamList34:'page',
        productInforesponseParamList35:'display quantity per page',
        productInforesponseParamList36:'ascending or not',
        productInforesponseParamList37:'descending or not',
        targetArearequestParamList11:'fields used to verify user rights',
        targetArearequestParamList12:'bearer + " " （space）+ token',
        targetArearequestParamList21:'satellite id',
        targetArearequestParamList22:'multiple choices are available,details are as follows',
        targetArearequestParamList31:'product type',
        targetArearequestParamList32:'single choice, details are as follows',
        targetArearequestParamList41:'data spectrum',
        targetArearequestParamList42:'multiple choices are available. Details are as follows',
        targetArearequestParamList51:'resolution',
        targetArearequestParamList52:'single choice, details are as follows',
        targetArearequestParamList61:'cloud cover',
        targetArearequestParamList62:'0-99 optional, default value is 50, query data no higher than this value',
        targetArearequestParamList71:'sidesway angle',
        targetArearequestParamList72:'0-45 optional, default value 45, query data no higher than this value',
        targetArearequestParamList81:'shooting start time',
        targetArearequestParamList82:'one time is allowed to be empty',
        targetArearequestParamList91:'shooting end time',
        targetArearequestParamList92:'one time is allowed to be empty',
        targetArearequestParamList101:'product quality',
        targetArearequestParamList102:'make one choice from A,B,C,D',
        targetArearequestParamList111:'geographical scope of query area',
        targetArearequestParamList112:'geojson format',
        targetArearesponseParamList31:'current area archive data(scene)',
        targetArearesponseParamList32:'total shooting area of current area (km2)',
        targetArearesponseParamList33:'current area coverage (km2)',
        targetArearesponseParamList34:'product archive data in the region(scene)',
        targetArearesponseParamList35:'total shooting area of products in the area (km2)',
        targetArearesponseParamList36:'product coverage area in the area (km2)',
        targetArearesponseParamList37:'current area coverage Geo',
        targetArearesponseParamList38:'coverage percentage',
        ArchiverequestParamList1:'fields used to verify user rights',
        ArchiverequestParamList2:'bearer + " " （space）+ token',
        ArchiveresponseParamList31:'Archive data(scene)',
        ArchiveresponseParamList32:'total shooting area (km2)',
        ArchiveresponseParamList33:'coverage area (km2)',
        ArchiveresponseParamList34:'coverage area (km2)',
        transitrequestParamList1:'longitude',
        transitrequestParamList2:'latitude',
        transitrequestParamList31:'satelliteid',
        transitrequestParamList32:'for example JL101A',
        transitrequestParamList4:'start time',
        transitrequestParamList5:'end time',
        transitresponseParamList31:'sidesway angle',
        transitresponseParamList32:'transit time',
        transitresponseParamList33:'transit time',
        transitresponseParamList34:'solar altitude angle',
        ProgrammingrequestParamList1:'customer id',
        ProgrammingrequestParamList2:'customer name',
        ProgrammingrequestParamList3:'cloud cover',
        ProgrammingrequestParamList41:'delivery time',
        ProgrammingrequestParamList42:'imaging 24, 48, 72 hours',
        ProgrammingrequestParamList51:'geometric requirements',
        ProgrammingrequestParamList52:'0：no limit 1：≤200m 2：≤100m',
        ProgrammingrequestParamList5:'imaging duration',
        ProgrammingrequestParamList6:'geographical scope',
        ProgrammingrequestParamList71:'imaging mode',
        ProgrammingrequestParamList72:'1: push scan imaging 2: gaze imaging 3: night light imaging 4: stereo imaging',
        ProgrammingrequestParamList8:'end shooting time',
        ProgrammingrequestParamList91:'frequency requirements',
        ProgrammingrequestParamList92:'1: by number 2: by frequency',
        ProgrammingrequestParamList10:'shooting interval',
        ProgrammingrequestParamList11:'shooting satellite',
        ProgrammingrequestParamList12:'start shooting time',
        ProgrammingrequestParamList131:'is it multi palace shooting',
        ProgrammingrequestParamList132:'0：No 1：Yes',
        ProgrammingrequestParamList141:'sensitive or not',
        ProgrammingrequestParamList142:'0：No 1：Yes',
        ProgrammingrequestParamList15:'priority',
        ProgrammingrequestParamList16:'product type',
        ProgrammingrequestParamList171:'radiation requirements',
        ProgrammingrequestParamList172:'0：no requirements 1：no obvious radiation',
        ProgrammingrequestParamList18:'demand name',
        ProgrammingrequestParamList191:'demand type',
        ProgrammingrequestParamList192:'0:point target 1:area target',
        ProgrammingrequestParamList20:'remarks',
        ProgrammingrequestParamList21:'resolution',
        ProgrammingrequestParamList22:'shooting times',
        ProgrammingrequestParamList23:'sidesway angle',
        ProgrammingrequestParamList241:'spectral band requirements',
        ProgrammingrequestParamList242:'0：no requirements 1：trispectrum 2：Tetra band',
        ProgrammingsponseParamList4:'order ID',
    },
    agriculture: {
        title: 'Remote Sensing Application in Agriculture',
        subTitle: 'The rapid acquisition and analysis of farmland crop information is the premise and basis of precision agriculture practice. The "Jilin-1" data objectively, accurately and timely provides various information of crop ecological environment and crop growth, providing support for agricultural production and practice.',
        title2:'Multi-spectral, Wide-range Data for Agricultural Development',
        subTitle2:'Facing the needs of agricultural production management, combining with the "red edge", short wave, medium wave and long wave infrared bands provided by "Jilin-1", the surface agricultural data information is quickly obtained, the precise monitoring of agricultural planting structure, crop growth, agricultural pests and diseases is realized, and the agricultural survey statistics, agricultural production management, crop yield estimation, pest control, agricultural insurance are formed.',
        plantingStructureMonitoring:'Planting structure monitoring',
        plantingStructureSubtitle:'Using the visible, near-infrared and short wave infrared bands of remote sensing data, supplemented by land use status data, ground survey data, agricultural historical statistics data, making analysis of spectral characteristics and texture characteristics of various crops in different phenological periods, a model of crop planting structure extraction is established.',
        plantingStructureService11:'Spatial distribution and planting area of single or multiple crops in the ',
        plantingStructureService12:'extraction area',
        plantingStructureService21:'Using time series and deep learning algorithm to classify remote sensing ',
        plantingStructureService22:'planting structure products is more accurate than similar products',
        plantingStructureService2Subtitle:'',
        plantingStructureImgTitle:'Distribution of crop planting structure in the Eighth Agricultural Division, Shihezi, Xinjiang in 2017',
        cropGrowthMonitoring:'Crop growth monitoring',
        cropGrowthMonitoringSubtitle:'According to the satellite image of "Jilin-1" with large width, multi-band, multi-resolution and high timeliness, the near real-time monitoring is carried out in the whole crop growth period, and the growth monitoring products are provided in combination with the remote sensing image data and Crop Phenology information, and the crop growth curve is provided before the crop harvest period to reflect the crop growth status information.',
        cropGrowthMonitoringImgTitle:'Crop growth in the Dakara region of southern Egypt in 2019',
        cropGrowthMonitoringService1:'Macro monitoring of regional crop growth',
        cropGrowthMonitoringService21:'Compared with the same period of history, the macro comparative',
        cropGrowthMonitoringService22:' monitoring of regional growth',
        droughtAssessment:'Drought assessment',
        droughtAssessmentSubtitle:'Based on the data of "Jilin-1" satellite, through modeling the data of ground temperature and crop physiological parameters, a drought monitoring model is established to evaluate the change of soil moisture content. With the characteristics of fast, objective and large-scale, the monitoring of soil moisture and drought is realized.',
        droughtAssessmentService1:'Provide surface soil moisture content and spatial distribution',
        droughtAssessmentService21:'Evaluate the drought level of farmland area to provide the spatial ',
        droughtAssessmentService22:'distribution and area of different drought levels',
        droughtAssessmentImgTitle:'Drought monitoring in Nong\'an County, Jilin Province, 2017-2018',
        floodMonitoring:'Flood monitoring',
        floodMonitoringSubtitle:'By using crop identification model, water extraction model and depth learning algorithm, combined with the changes of spectral characteristics after crop disaster, we can identify the disaster area and evaluate the disaster level, guide the work of disaster prevention and mitigation, assist the disaster impact assessment, and provide high-frequency remote sensing monitoring products of different scales.',
        floodMonitoringService11:'Provide a variety of spatial and spectral resolution data quickly through',
        floodMonitoringService12:'constellation joint planning',
        floodMonitoringService2:'Statistics of regional disaster degree and spatial scope',
        floodMonitoringImgTitle:'Flood disaster monitoring in Wuchang, Heilongjiang in 2018',
    },
    baseMap:{
        title:'One Picture of China\'s 5m Spectrum Shot by',
        title_:'"Jilin-1" in 2019',
        subtitle:'One picture of the latest and most complete satellite image in 2019, corresponding to rich spectral information L1 data, with a spatial resolution of 5m true color image. On September 29, all provincial capitals in China opened a free data download channel',
        onePicture:'The latest 5m resolution picture of China in 2019',
        onePictureSubtitle:'One picture of the latest and most complete satellite image in 2019 of China, corresponding to the rich spectral information L1 data, with a spatial resolution of 5m true color image, all data are obtained by Jilin-1 spectroscopic satellites 01 and 02. This model of satellite is equipped with a multispectral imager, short wave, medium wave and long wave infrared camera, with an on-board intelligent processing system, which can obtain a resolution of 5m, a width of 110km, and a spectrum of 26 bands.',
        timePhase:'Time phase',
        timePhaseContent:'2019.03~ 2019.08',
        resolutionRatio:'Resolution ratio',
        resolutionRatioContent:'5 m',
        spectrumBand:'Spectrum band',
        spectrumBandContent1:'red 630~680 nm',
        spectrumBandContent2:'green 525~600 nm',
        spectrumBandContent3:'blue 450~515 nm',
        cloud:'Cloud cover：<20% ',
        storage:'Storage mode：Each province stores in 1:25w standard (Hong Kong, Macao and Taiwan store by Region)',
        coordinateSystem:'Coordinate system：WGS-84',
        interSpectral:'Inter spectral registration accuracy: better than 1 pixel',
        onlineBrowsingAndDownloading:'Online Browsing and Downloading',
        onlineExperienceBtn:'Online experience',
        onlineBottom:'GS (2019) No. 1719 - Class A surveying and mapping qualification certificate No 1100471',
        L1ProductIndex:'L1 product index',
        technicalIndicators:'Technical indicators',
        params:'parameter',
        groundPixelResolution:'Resolution of ground pixel of point under the stars',
        groundPixelResolutionContent1:'(a)Multispectral spectrum:',
        groundPixelResolutionContent2:'B0-B6\'resolution is 5m/B7-B12\'resolution is 10m/B13-B19\'resolution is 20m',
        groundPixelResolutionContent3:'(b) Short wave infrared spectrum：',
        groundPixelResolutionContent4:'SW1-SW4\'resolution is 100m',
        groundPixelResolutionContent5:'(c)Mid wave infrared spectrum：',
        groundPixelResolutionContent6:'MW1（100m）',
        groundPixelResolutionContent7:'(d)Long wave infrared spectrum::',
        groundPixelResolutionContent8:'LW1（150m）',
        spectralChannel:'Spectral channel',
        spectralChannelContent1:'(a)Multispectral spectrum:',
        spectralChannelContent2:'(b)Short wave infrared spectrum：',
        spectralChannelContent3:'(c)Mid wave infrared spectrum：',
        spectralChannelContent4:'(d)Long wave infrared spectrum：',
        quantizationBits:'Quantization Bits',
        standardLandscapeSize:'Standard scene size (under the satellite)',
        trackHeight:'Track height',
        positioningAccuracy:'Uncontrolled positioning accuracy(CE90)',
        multichannelSpectrometer:'multichannelSpectrometer',
        checkFullBtn:'Check full standard product description',
        specialProductItems1:'Tree species classification of Huadian City, Jilin Province',
        specialProductItems2:'Investigation on garlic planting area in Pingyi, Shandong Province',
        specialProductItems3:'Surface cover of Xigaze, Tibet',
    },
    city:{
        title:'Application in Smart City',
        subtitle:'With the continuous advancement of the modernization of national governance system and governance capacity, the construction of "smart city" puts forward higher requirements for spatial information. Remote sensing big data is an innovative exploration to monitor urban changes and manage cities in real time, and it is an inevitable choice to enhance the comprehensive competitiveness and international influence of modern cities.',
        title2:'Remote Sensing + AI to Help the Construction of Smart City',
        subtitle2:'The rise and development of new technologies such as 5G, cloud computing and Internet plus provide more application scenarios for remote sensing big data services to smart city. Based on the high-resolution image of "Jilin-1", it integrates the macro and micro images of the city, extracts the data of urban land use and environmental monitoring, builds a comprehensive service platform of urban geographic information, and provides solutions for strengthening the unified management of the city.',
        buildingChangeDetection:'Building change detection',
        buildingChangeDetectionSubtitle:'In combination with the high-resolution satellite image of "Jilin-1" constellation, obtain the change of urban land use, provide vector map spot products twice a month for the supervision of construction engineering, provide information support for the law enforcement department to investigate and punish construction projects such as illegal construction and rush construction, and supervise the construction progress of large-scale projects, improve the efficiency  and enhance the credibility of law enforcement.',
        buildingChangeDetectionImgTitle:'Building change detection of Beihu District, Changchun City in 2018',
        buildingChangeDetectionService1:'Continuous monitoring of major project progress',
        buildingChangeDetectionService2:'Information extraction of building change location, area and type',
        buildingChangeDetectionService3:'Detection and identification of illegal buildings',
        urbanLandResourcesSurvey:'Urban land resources survey',
        urbanLandResourcesSurveySubtitle:'Land resource survey is the basic data of urban development planning. Through visible light and near-infrared data, we can obtain the current situation of urban land use and urban vegetation coverage, and help the urban management department to find out the background of the house and make a more reasonable development plan.',
        urbanLandResourcesSurveyService1:'Multi scale land use monitoring',
        urbanLandResourcesSurveyService2:'Distribution and area of various types of land',
        urbanLandResourcesSurveyImgTitle:'Land resources survey of Tianjin in 2019',
        urbanExpansionEvolution:'Urban expansion evolution monitoring',
        urbanExpansionEvolutionSubtitle:'Through long-term remote sensing data, the historical evolution of the city is obtained, and the grid map and vector map spot products are provided once a year, which are used by the urban management department, supplemented by the delimitation of the urban development boundary, to prevent the disordered spread of urban land and realize the sustainable use of land.',
        urbanExpansionEvolutionService11:'Grasp the law of urban evolution, delimit the boundary of urban development,',
        urbanExpansionEvolutionService12:' and prevent the disordered spread of urban land',
        urbanExpansionEvolutionService21:'Guide urban planning, improve urban land use efficiency and realize sustainable',
        urbanExpansionEvolutionService22:'land use',
        urbanExpansionEvolutionImgTitle:'1990-2016 urban expansion monitoring of Changchun City',
        urbanEcologicalEnvironment:'Evaluation of urban ecological environment quality',
        urbanEcologicalEnvironmentSubtitle:'Using high-resolution image, extracting the information of ground features, using supervised classification and decision tree method to extract various factors that affect the environmental quality, and finally get the comprehensive evaluation of environmental quality, which provides the basis for the rational planning and protection of urban areas.',
        urbanEcologicalEnvironmentService11:'According to the standard evaluation, evaluate the quality of urban ',
        urbanEcologicalEnvironmentService12:'ecological environment',
        urbanEcologicalEnvironmentService21:'Evaluate the long-term changes of ecological environment quality',
        urbanEcologicalEnvironmentService22:' and find out the reasons for the changes',
        urbanEcologicalEnvironmentImgTitle:'Evaluation of urban ecological environment quality in Changchun City from 1990 to 2016',
    },
    dataSetInfo:{
        airport:'airport target',
        harbour:'harbour target',
        nearby:'nearby',
        exploreMore:'explore more',
        viewLarge:'View large',
        imgName:'T2 terminal of Beijing Capital International Airport',
        imgLoction:'Chaoyang District of Beijing City',
        search: 'Please enter the place or lat&lon',
        seeImage: 'View large',
    },
    forestry:{
        title:'Natural Resources Monitoring',
        subtitle:'Focusing on the whole process of natural resources investigation, monitoring, evaluation and decision-making, "Jilin-1" has realized the transformation and upgrading from periodic investigation to dynamic monitoring through regular monitoring and rapid updating and provides technical support for the investigation and monitoring of natural resources of mountains, rivers, forests, fields, lakes and grasses.',
        title2:'Massive remote sensing data improved the ability of natural resources investigation and supervision',
        subtitle2:'The large amount of remote sensing satellite image data which comes from "Jilin-1" ,provides data support for the dynamic change information of natural resources on the earth. To meet the needs of natural resources investigation, monitoring, evaluation and decision-making, a comprehensive solution of "one map" of forest and grass resources, vegetation coverage, wetland type classification, forest fire monitoring, forest pest monitoring and ecological assessment is provided.',
        forestResourcesSurvey:'Forest resources survey',
        forestResourcesSurveyImgTitle:'Forest resources survey of Jilin City in 2017',
        forestResourcesSurveySubtitle:'Based on multi-source and multi temporal remote sensing data, terrain data, forest phenology data and other basic data, using the supervised and unsupervised classification methods such as artificial neural network, decision tree model, support vector machine to extract the land use type, forest type and forest type change information between multi temporal images.',
        forestResourcesSurveyService11:'Extract spatial distribution and area statistics of unique area or land',
        forestResourcesSurveyService12:' with multiple  species of trees',
        forestResourcesSurveyService2:'Provides services for surveys of forest resource status and changes',
        wetlandExtraction:'Extraction of wetland type',
        wetlandExtractionImgTitle:'Analysis of wetland types in chagan lake national nature reserve and peripheral protection zone in 2018',
        wetlandExtractionService11:'Extract spatial distribution and area statistics of unique area or land ',
        wetlandExtractionService12:'with multiple  species of wetland ',
        wetlandExtractionService2:'The classification accuracy is better than 85%',
        wetlandExtractionSubtitle:'Based on the observation data of multi-phase and multi-band by "jilin-1", using object oriented method to fully consider the spectral and spatial characteristics of ground objects and complete the extraction of wetland resource types.',
        naturalReserveMonitoring:'Nature reserve monitoring',
        naturalReserveMonitoringSubtitle:'According to the multi-scale segmentation of human activities in the nature reserve, the classification rule set is established, the information of human activities in the reserve is extracted, and the dynamic changes of human activities are analyzed by comparing the images of different periods before and after.',
        naturalReserveMonitoringService11:'Obtain the distribution of illegal logging, grazing, hunting, fishing, ',
        naturalReserveMonitoringService12:'medicine collection, reclamation, burning, mining, quarrying, sand ',
        naturalReserveMonitoringService13:'excavation, film and television shooting and other activities prohibited',
        naturalReserveMonitoringService14:'by laws and regulations in the nature reserve ',
        naturalReserveMonitoringService21:'Analyse the progress of road building or construction projects in',
        naturalReserveMonitoringService22:'nature reserves through multiple phases',
        naturalReserveMonitoringImgTitle:'Remote sensing information service platform for nature reserves',
        fireMonitoring:'Fire monitoring',
        fireMonitoringSubtitle:'Forest fire prevention and early warning is an important business of forest resource protection. Utilizing the "Jilin-1" satellite that has the characteristics of wide coverage and high revisit, and based on the spectral characteristics of forest fire point in the short wave infrared and thermal infrared bands of remote sensing image, forest fire point can be identified quickly, which provides support for forest fire prevention and early warning.',
        fireMonitoringService11:'Emergency monitoring, rapid identification of fire point, providing location ',
        fireMonitoringService12:'distribution and area of forest fire point ',
        fireMonitoringService21:'Using AI fire point identification and high frequency revisit of satellite to',
        fireMonitoringService22:' identify and warn',
        fireMonitoringService3:'The accuracy of fire point extraction is better than 90%',
        fireMonitoringImgTitle:'Fire monitoring in Brazil in 2019',
    },
    home:{
        contact1: 'Contact',
        contact2: 'Us',
        cardTitle1:'Archive',
        card1Subtitle:'Massive high-resolution image inquiry and ordering',
        cardTitle2:'Tasking',
        card2Subtitle:'Fast response and customized',
        cardTitle3:'Application',
        card3Subtitle:'Remote sensing one-stop service',
        cardTitle4:'Data Set',
        card4Subtitle:'More than 10 categories and millions of data',
        title:'Products and services',
        subtitle:'Using the remote sensing information products which integrated space and sky to serve 7 billion people in the world',

        card1sSubtitle: 'Image order',
        card2sSubtitle: 'Fast response',
        cardTitle3s: 'Sample',
        card3sSubtitle: 'Free downlod',
        card4sSubtitle: 'Categories',

        industryTitle: 'Industry application',
        industrySubTitle: '"Jilin-1" satellite remote sensing images have been widely used in land and resource monitoring, land surveying and mapping, mineral resource development, smart city construction, transportation facility monitoring, agricultural production estimation, forestry resource census, ecological environment monitoring, disaster prevention and mitigation and emergency response, etc.',

        satelliteImg:'Products',
        valueAddedProducts:'Solutions',
        applicationPlatform:'Applications',
        tools:'Tools',
        archivedData:'Archive',
        archivedDataSubtitle:'"Jilin-1" global massive high-resolution image inquiry and order, covering optical, video, night light, multispectral, three-dimensional,etc',
        programming:'Tasking',
        programmingPhotographySubtitle:'Control the "Jilin-1" satellite by programming, takes customized pictures according to  imaging time and location specified by the user, with the fastest 24-hour deliver',
        sampleData:'Sample data',
        sampleDataSubtitle:'Provide "jilin-1" a variety of remote sensing data,which can be downloaded for free after registration and login，sample data updated regularly',
        normalOpticalImage:'Ordinary optical image',
        normalOpticalImageSubtitle:'The ordinary optical image of "Jilin-1" includes resolutions of 0.72M, 0.75m, 0.92M and 1m, including blue, green, red, red edge and near-infrared band',
        luminousImage:'Luminous image',
        luminousImageSubtitle:'The luminous image of "Jilin-1" is the only sub meter level real color luminous remote sensing data product publicly available in the world.',
        video:'Video',
        videoSubtitle:'The single frame image resolution of "Jilin-1" video is up to 12K * 5K, and the storage size is 175m,and been sensor corrected and image stabilized processing',
        multispectralImage:'Multispectral image',
        multispectralImageSubtitle:'The multispectral image has a resolution of 5 meters a width of 110 kilometers, covering  26 spectral bands ranging from 450 nm to 13500 nm.,update once every 14 days',
        DEMDSMImage:'DEM / DSM image',
        DEMDSMImageSubtitle:'Realize 3D surface reconstruction, acquire high-precision digital surface and elevation model, and accurately reflect the details and elevation information of surface features',
        remoteSensingDataSet:'Remote sensing data set',
        remoteSensingDataSetSubtitle:'A large number of remote sensing images from "Jilin-1" contain more than ten categories and millions of data, which can be customized according to customer needs',
        onePictureOfChina:'One image of China',
        onePictureOfChinaSubtitle:'Based on the 5m resolution multispectral data of "Jilin-1", including one remote sensing image and one surface cover classification map',
        urbanRemoteSensingProducts:'Urban',
        urbanRemoteSensingProductsSubtitle:'Construction change detection, land resources investigation, solid waste monitoring,eco quality evaluation,etc',
        agriculturalRemoteSensingProducts:'Agricultural',
        agriculturalRemoteSensingProductsSubtitle:'Planting structure detection, crop growth monitoring , crop drought ,crop flood damage assessment remote sensing',
        forestryRemoteSensingProducts:'Forestry',
        forestryRemoteSensingProductsSubtitle:'Remote sensing monitoring of dominant tree species,forest fires,human activities in natural reserves, and dead trees',
        WaterRemoteSensingProducts:'Water',
        WaterRemoteSensingProductsSubtitle:'remote sensing monitoring of surface water resources, water quality, river and lake shoreline, flood disaster,etc',
        ecoEnvironmentalRemoteSensingProducts:'Eco environmental',
        ecoEnvironmentalRemoteSensingProductsSubtitle:'Straw burning monitoring, ecological environment assessment, heat island monitoring',
        access: 'Jilin-1 Data Access System',
        accessPlatform: 'Provide convenient, real-time, efficient and complete Jilin-1 satellite data access service for various data agents, data integrators and data application products',
        visualizationPlatform:'3D visualization platform',
        visualizationPlatformSubtitle:'It is a one-stop comprehensive service engine for all types of remote sensing information, which integrates browsing, management, processing and application. It is a unified delivery platform for Jilin-1 satellite data.',
        remoteSensingSupervisionServiceSystem:'Remote sensing supervision service system',
        remoteSensingSupervisionServiceSystemSubtitle:'With "Jilin-1" as the data guarantee, capable of realizing the whole process management of uploading, verifying, classifying, distributing and rectifying illegal buildings and illegal map spots',
        agriculturalInsurance:'Remote sensing service system of agricultural insurance',
        agriculturalInsuranceSubtitle:'Deeply integrate remote sensing data such as satellite, UAV and agricultural insurance business data to solve problems such as "accurate underwriting" and "fast claims settlement"',
        skyGroundIntegrated:'Sky ground integrated supervision system of Nature Reserve',
        skyGroundIntegratedSubtitle:'Realize the network, digitalization and intelligence of the monitoring and management work of the nature reserve, and carry out the monitoring of the integration of space and space in the nature reserve',
        riverChief:'River chief system information management system',
        riverChiefSubtitle:'On the basis of satellite remote sensing and satellite positioning technology, timely discover the changes of quantity, quality and structure of urban river and lake resources',
        EcologicalProtectionRedLine:'Remote sensing application system of ecological protection red line',
        EcologicalProtectionRedLineSubtitle:'Timely discover the behavior of destroying the red line of ecological protection, and comprehensively grasp the composition, distribution and dynamic change of the ecological system in the red line area',
        satelliteConstellationPlanningSystem:'Remote sensing satellite constellation planning system',
        satelliteConstellationPlanningSystemSubtitle:'Generate visible window and ground data transmission window of corresponding task for user requirements, generate satellite imaging plan, satellite command and ground station receiving plan',
        fastProcessingMachine:'Remote sensing data fast processing machine',
        fastProcessingMachineSubtitle:'A series of standardized processing, such as decryption and decompression of original data, geometric and radiometric correction after data demodulation, are completed quickly to generate standard image products',
        satellitePlanningSystem:'Satellite planning system',
        satellitePlanningSystemSubtitle:'Generate visible window and ground data transmission window of corresponding task for user requirements, generate satellite imaging plan, satellite command and ground station receiving plan',
        imageProcessingKit:'Spectral satellite image processing kit',
        imageProcessingKitSubtitle:'Processing and production of value-added information products based on the multispectral data of Jilin-1 satellite, and providing visualization and interaction of data and results',
        dataAccessSystem:'Jilin-1 data access system',
        dataAccessSystemSubtitle:'Provide convenient, real-time, efficient and complete "Jilin-1" satellite data access services for all kinds of data agents, data integrators and data application products',
        satelliteTitle:'"Jilin-1" constellation',
        satelliteTitleSubtitle:'Jilin-1 satellite constellation is the largest commercial remote sensing satellite constellation in China. The ability of "jilin-1" constellation to revisit any place in the world in a day has reached 4-7 times, and it can respond to emergency tasks in 11 minutes at the fastest.',
        opticalA:'Jilin-1GXA',
        video0102:'Jilin-1SP01/02',
        lingQiao:'Jilin-1LQ',
        video03:'Jilin-1SP03',
        video0408:'Jilin-1SP04-08',
        guangPu0102:'Jilin-1HP01/02',
        gaoFen03A:'Jilin-1GF03A',
        gaoFen02A:'Jilin-1GF02A',
        gaoFen02B:'Jilin-1GF02B',
        kuanFu:'Jilin-1KF01',
        dataCoverage:'Data coverage',
        dataCoverageSubtitle:'Sixteen satellites of "jilin-1" have been in orbit, with 4-7 one-day revisits to any place in the world',
        cooperativePartner:'Cooperative partner',
        cooperativePartnerSubtitle:'Gather excellent partners, build remote sensing ecology,create value for users',
        bottom:'You can see whatever you want, buy whatever you need, all in Chang Guang E-Mall',
        bottomSubtitle:'Register now',
    },

    userBasicInfo:{
        img: 'Default avatar',
        info: 'Basic Information',
        account: 'Account',
        name: 'Real name',
        change: 'modify',
        save: 'save',
        phone: 'Phone',
        email: 'Email',
        password: 'Password',
        company: 'Company',
        industry: 'Industry',
        position: 'Position',
        close: 'Close',
        alert: 'Information modified successfully',
        alert1: 'Information modification failed',
        alert2: 'Real name cannot be empty',
        alert3: 'Email cannot be empty',
        alert4: 'Company cannot be empty',
        alert5: 'Industry cannot be empty',
        alert6: 'Position cannot be empty',
    },
    myOrder: {
        loading: 'loading',
        close: 'close',
        myOrder: 'My Order',
        all: 'All',
        ToBePaid: 'To Be Paid',
        ongoing: 'Ongoing',
        done: 'Completed',
        cancel: 'Cancelled',
        orderNum: 'Enter order number',
        endTime: 'End Time',
        startTime: 'Start Time',
        orderNum1: 'Order Number',
        orderType: 'Order Type',
        archivedData: 'Archived Data',
        tasking: 'Tasking',
        createTime: 'Creation time',
        productType: 'ProductType',
        general: 'General Optics',
        luminous: 'Luminous',
        video: 'Video',
        multispectral: 'Multispectral',
        payTime: 'Payment time',
        status: 'Status',
        money: 'Amount',
        operator: 'Operator',
        download: 'Download',
        detail: 'Detail',
        pay: 'Pay',
        noData: 'No Data',
    },
    personalCenterList: {
        close: 'close',
        personalCenter: 'Personal Center',
        info: 'Basic Information',
        myOrder: 'My Order',
        offersAndDiscounts: 'Offers and Discounts',
        coupons: 'Coupons',
        memberSystem: 'Membership System',
        contractAndInvoice: 'Contracts and Invoices',
        contractManagement: 'Contract Management',
        invoiceManagement: 'Invoice Management',
        noOpen: 'Not yet open~~',
    },
    changePhone: {
        account: 'Account Settings',
        changePhone: 'Modify bound phone number',
        sureUser: 'To confirm that it is your own operation, please complete the following verification',
        oldPhone: 'Old Phone',
        code: 'Valid Code',
        getCode: 'Get Code',
        resend:'Resend',
        nextStep: 'Next Step',
        info: 'Account can log in all products for company',
        NewPhone: 'New Phone',
        prefix: 'Prefix',
        sure: 'confirm',
        success: 'Your mobile number has been modified successfully',
        back: 'Back to personal center',
        rule: 'This item cannot be empty',
        rule1: 'Incorrect phone number format',
        rules2: 'The original phone number cannot be the same',
        rules3: 'Phone number must be a number',
        phoneCodeMessage: 'Verification code error',
        newPhoneCodeMessage: 'Malformed phone number',
        newPhoneCodeMessage1: 'Phone number cannot be empty',
        newPhoneCodeMessage2: 'Incorrect phone number or verification code',
    },
    invoiceManagement:{
        loading:'Loading',
        invoiceManagement:'Invoice Management',
        invoiceManagementPs1:'The invoice is only for the amount already consumed. No invoice can be issued for the amount deducted such as coupon.',
        invoiceManagementPs2:'The invoice will be sent out 3-4 working days after the completion of the order. Please wait patiently.',
        invoiceInformation:'Invoice Information',
        manageInvoiceInformation:'Manage Invoice Information',
        defaultTitle:'Default Title',
        invoiceType:'Invoice Type',
        noInvoiceDefaultInformation:'No default invoice information',
        deliveryAddress:'Delivery Address',
        manageDeliveryAddress:'Manage Delivery Address',
        defaultRecipient:'Default Recipient',
        noDefaultDeliveryAddress:'No default delivery address',

        invoiceRecords:'Invoice Records',
        searchInvoiceRecords_orderNumber:'Please enter the order number',
        searchInvoiceRecords_startTime:'Start time',
        searchInvoiceRecords_endTime:'End time',

        applyTime:'Apply Time',
        invoiceMedium:'Invoice Medium',
        invoiceAmount:'Invoice Amount',
        invoiceStatus:'Status',
        invoiceStatus_all:'all',
        invoiceStatus_completed:'completed',
        invoiceStatus_uncompleted:'uncompleted',
        invoiceOperation:'Operation',
        preview:'preview',
        detail:'details',
        noInvoiceRecords:'No Invoice Records',

    },
    invoiceInfoManagement:{
        loading:'Loading',
        close:'Close',

        title: 'Ensure that the invoice information provided is consistent with the registration information reserved in the tax authorities',
        type: 'Invoice type',
        comInvoice: 'VAT general invoice',
        specialInvoice: 'VAT special invoice',
        companyName: 'Company',
        enterCompany: 'Enter company name',
        code: 'Taxpayer iden',
        enterCode: 'Enter taxpayer identification',
        companyAdress: 'Address',
        companyAdress1: 'Company address',
        enterAdress: 'Enter company address',
        phone: 'Telephone',
        enterPhone: 'Enter work telephone',
        bank: 'Bank',
        enterBank: 'Enter bank',
        bankAccount: 'Bank Account',
        enterBankAccount: 'Enter bank Account',
        isDefaultInvoice: 'Set as default header',
        sure: 'confirm',

        deleteText:'Are you sure you want to delete the invoice information?',
        deleteOk:'confirm',
        cancel:'cancel',

        invoiceManagement:'Invoice Management',
        invoiceInfoManagement:'Invoice Information Management',
        invoiceInfoManagementPs1:'VAT invoices are only available to customers in mainland China. Hong Kong, Macao, Taiwan and overseas enterprises cannot issue such invoices',
        invoiceInfoManagementPs2:'You can create VAT plain invoice templates or VAT special invoice templates',
        invoiceInfoManagementPs3:'When creating the VAT invoice template and VAT special invoice, the invoice header can be set manually to support modification',
        invoiceInfoManagementPs4:'Support for creating multiple shipping address templates, support for modification',
        invoiceInfoManagementPs5:'Refund and invoicing are not supported. Please fill in the invoice and address information carefully when submitting the order. Once the order is submitted, it is not supported to modify the invoice and address information',
        more:'More',
        collapse:'Collapse',

        invoiceInfo:'invoice Information',
        addInvoiceInfo:'Add Invoice Information',
        invoiceTitle:'Invoice Title',
        invoiceCode:'Taxpayer Identification',
        invoiceType:'Invoice Type',
        operation:'Operation',

        setToDefault:'Set as the default',
        defaultTitle:'Default Title',
        modify:'Modify',
        delete:'Delete',
        noInvoiceInfo1:'No invoice template is available, please',
        noInvoiceInfo2:'add invoice information',

    },
    recipientInfoManagement:{
        loading:'Loading',
        close:'Close',

        recipientName: 'Name',
        enterName: 'Enter Recipient\'s name',
        recipientPhone: 'Mobile',
        enterRecipientPhone: 'Enter Recipient mobile',
        enterRecipientPhone1: '+86 (Chinese Mainland）',
        recipientAdress: 'Addr',
        addressProvince: 'Select province',
        addressCity: 'Select city',
        addressCounty: 'Select area',
        addressDetail: 'Detailed addr',
        enteraddressDetail: 'Please enter the detailed address',
        isDefaultInvoice1: 'Set as default receiving address',
        sure: 'confirm',
        cancel:'cancel',

        deleteAddressText:'Are you sure you want to delete the shipping address?',
        deleteOk:'Delete',


        invoiceManagement:'Invoice Management',
        deliveryAddressManagement:'Address Management',
        address:'Address',
        addAddress:'Add Address',
        management_name:'Name',
        management_mobile:'Mobile',
        management_address:'Address',
        management_operation:'Operation',

        setToDefault:'Set as the default',
        defaultTitle:'Default Address',
        modify:'Modify',
        delete:'Delete',
        noAddressInfo1:'No address template is available, please',
        noAddressInfo2:'add address',
    },

    myCoupons: {
        loading: 'Loading',
        close: 'Close',
        coupons: 'Coupons',
        couponsRule: 'Rules：',
        couponsTip1: '1. A product ID can only use up to one full discount coupon, one discount coupon (setting can be superimposed) / one full discount coupon or one discount coupon (setting can not be superimposed), the payment is reduced and exempt according to the face value, and only if it is satisfied The discount or full reduction can only be made when the amount is required. By default, the method with the largest amount of reduction and exemption is selected. If there are more discounts or discounts, the user will be selected by default. If there are multiple coupons of the same type, only one coupon of this type can be used.',
        couponsTip2: '2. Coupons can only be deducted from the order amount, and the part of the discount amount exceeding the order amount cannot be used again and cannot be exchanged for cash.',
        couponsTip3: '3. Invoices such as coupons cannot be invoiced',
        couponsTip4: '4. Coupons have a limited period of use, and cannot be used after the expiration date',
        learnMore: 'Learn More',
        up: 'Up',
        count: 'Count：',
        id: 'Coupon/ID',
        type: 'Type',
        all: 'All',
        discount: 'Discount',
        markDown: 'Mark Down',
        priceLimit: 'Price Limit(￥)',
        source: 'Source',
        event: 'Event',
        system: 'System',
        code: 'Code',
        eventRule: 'Event Rule',
        validUntil: 'Valid Until',
        applicable: 'Applicable Product',
        generalOptics: 'General Optics',
        luminous: 'Luminous',
        video: 'Video',
        multispectral: 'Multispectral',
        operate: 'Operate',
        useNow: 'Use Now',
        delete: 'Delete',
        nodata: 'No Data',
        deleteSuccess: 'Delete Succeed',
        activate: 'Activate',
        useable: 'Useable',
        used: 'Used',
        expired: 'Expired'
    },

    couponsActivation: {
        loading: 'Loading',
        close: 'Close',
        coupons: 'Coupons',
        activate: 'Activate Coupons',
        tip1:'1. The coupon activation code is 16 digits. The activation is only for the coupons obtained offline, and the coupons issued by the system and self-collected do not need to be activated',
        tip2:'2. If you have any questions about the coupon, please contact customer service phone',
        input: 'Please enter the activation code',
        code: 'Code',
        code12:'Please enter the 12-digit activation code',
        clear: 'Clear',
        activate2: 'Activate',
        back: 'Back',
        top12: 'The maximum number of activation codes is 12',
        wrong: 'Please enter the correct activation code',
        success: 'Activation code redeemed successfully',
        used: 'The activation code has been used',
        expired: 'The activation code has expired',
        notExist: 'The activation code does not exist'
    },
    pricing: {
        dataPrice: 'Jilin No.1 Data Pricing',
        dec: 'Multiple types of satellite data have lower price, faster response and better service to meet your needs in an all-round way',
        getMore: 'Get more quotes',
        dataType: 'Data Type',
        type1: 'General optics',
        type2: 'Multispectral',
        type3: 'Luminous',
        type4: 'Video',
        resolving: 'Resolution',
        resolving1: 'Better than 1m',
        resolving2: 'Better than 5m',
        reTitle: ' The data in "Jilin No.1" constellation remote sensing image database can be inquired and ordered in remote sensing e-shopping, and the standard product can be delivered immediately after online payment, and the fusion inlay office can be delivered within 5 working days after payment. "',
        archivedData: 'Archive Data',
        archivedData1: '45 yuan/km2',
        archivedData2: '5 yuan/km2',
        archivedData3: '100 yuan/km2',
        archivedData4: '25,000 yuan/section',
        archivedTitle: ' In the case of reference weather forecast and programming conflict, according to the customer\'s requirements'+

            "Normal queue processing, data shooting within 7-60 days, shooting \n"+

            'data delivered within 5 working days after, for routine programming services.',
        generalPro: 'General programming',
        generalPro1: '90 yuan/km2',
        generalPro2: '9 yuan/km2',
        generalPro3: '180 yuan / km2',
        generalPro4: '45,000 yuan/section',
        generalTitle: '24 to 7 days after order submission and 3 \n'+
            'data delivered within working days or specified time specified area not on track \n'+
            "Capture the data in the task, and serve for fast programming. Fast programming service \n "+
        'we can\'t filter the influence of weather factors.',
        fastProgram: 'Fast programming',
        fastProgram1: '240 yuan/km2',
        fastProgram2: '50000 yuan/Time',
        fastTitle: 'Provides the fastest programming response time, after the user specifies the shooting date, the \n '+
            'no more than 24 hours from the start of the injection to the delivery of data, which is an emergency \n'+
            'programming services. The emergency programming service was unable to filter the effects of weather factors.',
        emergencyPro: 'Emergency programming',
        emergencyPro1: 'Over 100000 yuan/Time',
        buyNow: 'Order now',
        title: 'Common Problem',
        card1Title: 'What are the default processing methods for data products',
        card1Content1: 'and',
        card1Content2: 'product level to complete',
        card1Content3: 'Radiation correction',
        card1Content4: 'caused by sensors and satellite platforms',
        card1Content5: 'Error correction',
        card1Content6: 'optimized image level',
        card1Content21: 'Product is by',
        card1Content22: 'Radiation correction, sensor, Bell color reconstruction',
        card1Content23: 'processed products are accompanied by RPC model parameter files for each frame',
        card1Content31: 'spatial registration and framing',
        card1Content32: 'after the establishment of the video image, with the main frame image and RPC model parameter file.',
        card1Content33: 'Click to view "Jilin No.1" standard product description',
        card2Title: 'Can data products do fusion and mosaic processing',
        card2Content11: 'All general optical, multispectral and luminous images',
        card2Content12: 'default without fusion tessellation',
        card2Content21: 'Data required',
        card2Content22: 'Fusion processing',
        card2Content23: '10% of the total cost of the original data',
        card2Content31: 'Mosaic treatment',
        card2Content32: '20% of the total cost of the original data',
        card2Content33: ' Video image after framing (AVI) does not support tessellation',
        card3Title: 'What are the starting rules for various types of data products',
        card3Content11: 'Archived',
        card3Content12: 'Data: -Remote sensing e-buy',
        card3Content13: 'online tailoring purchase',
        card3Content14: 'view tutorial',
        card3Content15: 'minimum size supported',
        card3Content21: 'Programming',
        card3Content22: 'data：',
        card3Content23: 'The minimum starting area is',
        card3Content24: 'The default is',
        card3Content25: 'with a duration of 30s',
        card3Content26: 'the staring video of the specified area， The area is ',
        card4Title: 'How long is the data delivery time',
        card4Content11: 'After payment of standard products',
        card4Content12: 'pay down',
        card4Content13: 'after the fusion inlay treatment',
        card4Content14: 'after the fusion inlay treatment',
        card4Content15: 'is paid',
        card4Content21: 'After successful data shooting',
        card4Content22: 'Within 5 working days ',
        card4Content23: 'Delivery data',
        card4Content31: 'Within 3 working days',
        card4Content32: 'Delivery，Unable to filter the influence of weather factors',
        card4Content41: 'From note up to data delivery',
        card4Content42: 'not more than 24 hours',
        card4Content43: '，Unable to filter the influence of weather factors',
        contactUs: 'Contact Us',
        market: 'market',
        phone: 'phone',
        company: 'Changguang Satellite Technology Co., Ltd',
        close: 'close',
        buzhichi: 'Your browser does not support video playback',
    },
    constellation: {
        title1: 'Jilin No.1 constellation',
        title2: 'Multiple types of satellite data have lower price, faster response and better service to meet your needs in an all-round way',
        btn: 'Ordering data',
        description: 'From the establishment of Changguang Satellite Technology Co., Ltd. in December 2014 to February 2020, the company has 25 satellites in orbit, among which there are 01 satellites in high score, 02 (C, D, f) satellites in high score in research'+

        'high score 03 series stars (high score 03b01-08) (high score 03c-01), video 09 stars, high score 04A stars, etc. Among them, the high score 03 series star has the characteristics of low cost, low weight, low power consumption, high resolution, etc., which is the main networking satellite model of "Jilin No.1" constellation'+

        'Its launch will greatly improve the service ability of Jilin No. 1 satellite constellation and provide users with the most timely remote sensing image ability. By February 2020, Jilin No.1 satellite constellation will have 4-6 revisits per day, with a target number of 300 visits per day'+

            '2.2 million square kilometers are acquired in a single day, and the effective area is about 1.3 million square kilometers, of which 5m accounts for 70%.',
        jilin: 'Jilin No.1',
        param: ' Parameter',
        imageMode: 'Imaging mode',
        resolution: 'Resolution',
        bounds: 'Bounds',
        accuracy: 'Accuracy',
        track: 'Track',
        range: 'Width',
        cover: 'Ground coverage',
        swingAngle: 'Maximum swing angle',
        imageTime: 'Continuous imaging time',
        mass: 'Total satellite mass',
        life: 'Design life',
        revisitPeriod: 'Revisit cycle',
        rocket: 'Carrier rocket',
        launchSite: 'Launch site',
        channel: 'Digital channel',
        img1: 'Urban industry remote sensing products',
        img2: 'Agricultural remote sensing products',
        img3: 'Forestry industry Remote Sensing Products',
        img4: 'Water conservancy remote sensing products',
        img5: 'Ecological environmental protection remote sensing products',
        desc: '"Jilin-1" satellite remote sensing images have been widely used in land and resources monitoring, land mapping, mineral resources development, smart city construction, transportation facilities monitoring, agricultural production estimation, forestry resources census, ecological environment monitoring, disaster prevention and mitigation, and emergency response .',
        nosupport: 'Your browser does not support video playback',
        backTop: 'Back to top',
        satellite1Name: 'Optical A Satellite',
        satellite1Text: '"Jilin One" Optical A Star is a high-resolution commercial remote sensing satellite independently developed by Changguang Satellite Technology Co., Ltd. It was successfully launched at the Jiuquan Satellite Launch Center on October 7, 2015, carrying the Long March 2 D carrier rocket Complete high-resolution push-scan image acquisition.',
        satellite1ImageMode: 'Conventional push sweep, large angle side swing, strip stitching, stereo imaging',
        satellite1Resolution: 'Full color ≤0.72 meters, multi-spectral ≤2.88 meters',
        satellite1Bounds: 'Push-broom: full color 400-800nm blue 450-520 nm green 520-600 nm red 630-690 nm analog near infrared 690-800 nm',
        satellite1Accuracy: '200 meters',
        satellite1track: 'Orbit type: Solar synchronous orbit Orbital height: 650 km Orbital inclination: 98.04 ° When descending the focal point: 10:30 am',
        satellite1range: '≥11.6 km',
        satellite1cover: 'No description',
        satellite1imageTime: 'No description',
        satellite1mass: '<420kg',
        satellite1life: '＞3 years',
        satellite1revisitPeriod: '3.3 days',
        satellite1rocket: 'Long March II D carrier rocket',
        satellite1launchSite: 'China Jiuquan Satellite Launch Center',

        satellite2Name: 'Video 01/02 Satellite',
        satellite2Text: 'Video 01/02 is the first-generation color video satellite independently developed and produced by Changguang Satellite Technology Co., Ltd., and the world ’s first color video satellite. It was successfully launched at the Jiuquan Satellite Launch Center in October 2015 with the Long March 2 D carrier rocket. Launch, with video gaze imaging and gaze spot beam data transmission capabilities.',
        satellite2ImageMode: 'Staring at the video',
        satellite2Resolution: '1.13 meters',
        satellite2Bounds: 'Video: RGB (Bell coded color)',
        satellite2Accuracy: '500 meters',
        satellite2track: 'Orbit type: Solar synchronous orbit Orbital height: 650km Orbital inclination: 98.04 ° When descending the focal point: 10:30 am',
        satellite2range: 'No description',
        satellite2cover: '4.6km×3.4km',
        satellite2imageTime: 'No description',
        satellite2mass: '<95 kg',
        satellite2life: '＞1 yaers',
        satellite2revisitPeriod: '3.3 days',
        satellite2rocket: 'Long March II D carrier rocket',
        satellite2launchSite: 'China Jiuquan Satellite Launch Center',

        satellite3Name: 'Smart Verification Satellite',
        satellite3Text: 'Smart Verification Star is Changguang Satellite Technology Co., Ltd.\'s technology verification satellite for non-orbit imaging and domestic CMOS sensors. It uses a large number of industrial-grade devices and is the world\'s first smart imaging satellite. It was successfully launched at the Jiuquan Satellite Launch Center in October 2015 with the Long March No. 2 D carrier rocket, and it has multiple imaging modes.',
        satellite3ImageMode: 'Conventional push-broom, staring video, smart imaging, stereo imaging',
        satellite3Resolution: '4.7 meters',
        satellite3Bounds: 'Video: Full color',
        satellite3Accuracy: '500 meters',
        satellite3track: 'Orbit type: Solar synchronous orbit Orbital height: 650km Orbital inclination: 98.04 ° When descending focus: 10:30 am',
        satellite3range: '9.6 km',
        satellite3cover: 'No description',
        satellite3imageTime: 'No description',
        satellite3mass: '<57 kg',
        satellite3life: '＞1 years',
        satellite3revisitPeriod: '3.3 days',
        satellite3rocket: 'Long March II D carrier rocket',
        satellite3launchSite: 'China Jiuquan Satellite Launch Center',

        satellite4Name: 'Video 03 Satellite',
        satellite4Text: 'On January 9, 2017, the video 03 Star (Forest One), independently developed by Changguang Satellite Technology Co., Ltd., was successfully launched at the Jiuquan Satellite Launch Center with the Kuaizhou-1 A carrier rocket.',
        satellite4ImageMode: 'Staring at video, regular push scan',
        satellite4Resolution: '0.92 meters',
        satellite4Bounds: 'Video: RGB (Bell coded color)',
        satellite4Accuracy: '200 meters',
        satellite4track: 'Orbit type: Solar synchronous orbit Orbital height: 535.35km When descending the focal point: 10:30 am',
        satellite4range: 'No description',
        satellite4cover: '11km×4.5km',
        satellite4imageTime: '120s (one imaging）',
        satellite4mass: '<57 kg',
        satellite4life: '1-3 years',
        satellite4revisitPeriod: '3.3 days',
        satellite4rocket: 'Kuaizhou-1 small launch vehicle',
        satellite4launchSite: 'China Jiuquan Satellite Launch Center',

        satellite5Name: 'Video 04-06 Satellite',
        satellite5Text: 'On November 21, 2017, the "Jilin One" video 04-06 star (Zodanli 159 Jilin One satellite constellation) independently developed by Changguang Satellite Technology Co., Ltd., was launched on Taiyuan satellite with the Long March 6 carrier rocket. The center was successfully launched.',
        satellite5ImageMode: 'Gaze video imaging, conventional push sweep, low-light imaging, inertial space imaging',
        satellite5Resolution: '1 meters',
        satellite5Bounds: 'Video: RGB (Bell Coded Color) Push Scan: Full Color 450-800nm Blue 450-510nm Green 510-580nm Red 630-690nm Red Edge 705-745nm Near Infrared 770-895nm',
        satellite5Accuracy: '100 meters（CE90）',
        satellite5track: 'Orbit type: Solar synchronous orbit Height of orbit: 535.35km When descending the focal point: 12:00 am',
        satellite5range: 'No description',
        satellite5cover: '19km×4.5km',
        satellite5imageTime: '120s (one imaging）',
        satellite5mass: '<208 kg',
        satellite5life: '＞3years',
        satellite5revisitPeriod: 'No description',
        satellite5rocket: 'Long March 6 launch vehicle',
        satellite5launchSite: 'China Taiyuan Satellite Launch Center',

        satellite6Name: 'Video 07/08 Satellite',
        satellite6Text: 'On January 19, 2018, the "Deqing No. 1" (07 stars in "Jilin No. 1" video) and "Forest No. 2" (08 stars in the Jilin No. 1 video) independently developed by Changguang Satellite Technology Co., Ltd. were equipped with the Long March The 11th launch vehicle was successfully launched at the Jiuquan Satellite Launch Center.',
        satellite6ImageMode: 'Gaze video imaging, conventional push sweep, low-light imaging, inertial space imaging',
        satellite6Resolution: '1 meters',
        satellite6Bounds: 'Video: RGB (Bell Coded Color) Push Scan: Full Color 450-800nm Blue 450-510nm Green 510-580nm Red 630-690nm Red Edge 705-745nm Near Infrared 770-895nm',
        satellite6Accuracy: '100 meters（CE90）',
        satellite6track: 'Orbit type: Solar synchronous orbit Orbital height: 535.35km When descending the focal point: 10:30 am',
        satellite6range: 'No description',
        satellite6cover: '19km×4.5km',
        satellite6imageTime: '120s (one imaging）',
        satellite6mass: '<208 kg',
        satellite6life: '＞3 years',
        satellite6revisitPeriod: 'No description',
        satellite6rocket: 'Long March 11 Launch Vehicle',
        satellite6launchSite: 'China Jiuquan Satellite Launch Center',

        satellite7Name: 'High Score 02A / B Satellite',
        satellite7Text: 'On November 13, 2019, the high score 02A star independently developed by Changguang Satellite Technology Co., Ltd. was successfully launched at the Jiuquan Satellite Launch Center with the Kuaizhou-1A carrier rocket. On December 7, 2019, a high score 02B star independently developed by Changguang Satellite Technology Co., Ltd. was successfully launched at the Taiyuan Satellite Launch Center with the Kuaizhou-1A rocket. Resolution, large width, high positioning accuracy, high-speed data transmission and other characteristics.',
        satellite7ImageMode: 'Routine push sweep',
        satellite7Resolution: 'Full color is better than 0.75 meters, multi-spectral is better than 3 meters',
        satellite7Bounds: 'Full color 450-700nm blue 450-510nm green 510-580nm red 630-690nm near infrared 770-895nm',
        satellite7Accuracy: 'Better than 20 meters',
        satellite7track: 'Orbit type: Solar synchronous orbit Height of orbit: 535.35 km Orbital semi-major axis 6913.49 km Orbital inclination: 97.54 ° When descending focal point: 11:30 am',
        satellite7range: 'Better than 40 km',
        satellite7cover: 'No description',
        satellite7imageTime: 'No description',
        satellite7mass: '<230 kg',
        satellite7life: '＞3 years',
        satellite7revisitPeriod: 'No description',
        satellite7rocket: 'Kuaizhou-1A carrier rocket',
        satellite7launchSite: 'China Jiuquan / Taiyuan Satellite Launch Center',
        satellite7channel: 'No description',

        satellite8Name: 'Spectrum 01/02 Satellite',
        satellite8Text: 'On January 21, 2019, "Jilin No. 1" Spectrum 01 (Jilin Lincao No. 1) and "Jilin No. 1" Spectrum 02 (Wenchang Chaoshao No. 1) independently developed by Changguang Satellite Technology Co., Ltd. were equipped with Long March 11. The carrier rocket was successfully launched at the Jiuquan Satellite Launch Center.',
        satellite8ImageMode: 'Conventional push sweep, low-light imaging, inertial space imaging',
        satellite8Resolution: 'Visible near-infrared: 5m; short-wave and medium-wave infrared: 100m; long-wave infrared: 150m',
        //satellite8Bounds: '视频：RGB（贝尔编码彩色） 推扫：全色 450-800nm 蓝色450-510nm 绿色 510-580nm 红色 630-690nm 红边 705-745nm 近红外 770-895nm',
        satellite8Accuracy: '50 meters (CE90)',
        satellite8track: 'Orbit type: Solar synchronous orbit Height of orbit: 528.75km When descending the focal point: 12:00 am',
        satellite8range: '110 km',
        satellite8cover: 'No description',
        satellite8imageTime: '60s (one imaging）',
        satellite8mass: '<202 kg',
        satellite8life: '＞3 years',
        satellite8revisitPeriod: 'No description',
        satellite8rocket: 'Long March 11 Launch Vehicle',
        satellite8launchSite: 'China Jiuquan Satellite Launch Center',

        satellite9Name: 'High Score 03A Satellite',
        satellite9Text: 'On June 5, 2019, the "Jilin No. 1" high score 03A star independently developed by the company was successfully launched in the Yellow Sea in China. Innovative technologies such as lightweight structural design, highly integrated electronics systems, high-resolution / ultra-lightweight / low-cost cameras are used. It has the characteristics of low cost, low power consumption, light weight, high resolution, etc.',
        satellite9ImageMode: 'Conventional push-broom, multi-target push-broom imaging, space target imaging',
        satellite9Resolution: 'Better than 1 m',
        satellite8Bounds: 'Full color 450-700nm blue 450-510nm green 510',
        satellite9Accuracy: 'Better than 100 meters (CE90, double star sensitive effective area)',
        satellite9track: 'Orbit type: Solar synchronous orbit Height of orbit: 535 km Orbital semi-major axis 6913.14 km Orbital inclination: 97.336 ° When descending the focal point: 11:00 am',
        satellite9range: 'Better than 17 km',
        satellite9cover: 'No description',
        satellite9imageTime: 'No description',
        satellite9mass: '<40 kg',
        satellite9life: '＞3years',
        satellite9revisitPeriod: 'No description',
        satellite9rocket: 'Long March 11 Launch Vehicle',
        satellite9launchSite: 'Yellow Sea in China',
        satellite9channel: 'No description',

        satellite10Name: 'Wide format 01A Satellite',
        satellite10Text: 'On January 15, 2020, the wide-range 01 satellite (Hongqi-1-H9) independently developed by Changguang Satellite Technology Co., Ltd. was successfully launched at the Taiyuan Satellite Launch Center with the Long March 2 D carrier rocket. The widest sub-meter optical remote sensing satellite has the characteristics of high precision, ultra-wide width, high-speed storage, and high-speed digital transmission. It can obtain remote sensing images with panchromatic resolution better than 0.75m and multispectral resolution better than 3m.',
        satellite10ImageMode: 'Conventional push-broom, high-angle side-swing imaging',
        satellite10Resolution: 'Full color is better than 0.75 meters, multi-spectral is better than 3 meters',
        satellite10Bounds: 'Full color 450-700nm blue 450-510nm green 510-580nm red 630-690nm near infrared 770-895nm',
        satellite10Accuracy: '20 meters (CE90)',
        satellite10track: 'Orbit type: Solar synchronous orbit Orbital height: 481.56 km Orbital semi-major axis 6859.70 km Orbital inclination: 97.336 ° When descending the focal point: 10:00 am',
        satellite10range: 'Better than 136 km',
        satellite10cover: 'No description',
        satellite10imageTime: 'No description',
        satellite10mass: '<1300 kg',
        satellite10life: '＞5 years',
        satellite10revisitPeriod: '4 days',
        satellite10rocket: 'Long March II D carrier rocket',
        satellite10launchSite: 'China Taiyuan Satellite Launch Center',
        //satellite10channel: '暂无描述',
        satellite11Name:'High Score 03-1 Group Satellites',
        satellite11Text:'On September 15, 2020, the "Jilin No.1" High Score 03-1 group satellites independently developed by the company, carrying the Long March 11 carrier rocket, was successfully launched in the Yellow Sea of China. The High Score 03-1 group satellites includes three High Score 03C video imaging satellites and six Gaofen 03B push broom imaging satellites. The design concept of High Score 03-1 group of satellites and High Score 03A satellite has the characteristics of low cost, low power consumption, light weight, high resolution and low cost.',
        satellite11ImageMode:'High Score 03B pushbroom Satellite: conventional pushbroom, multi-target pushbroom imaging and space target imaging; High Score 03C Video Satellite: conventional gaze imaging, multi-target gaze imaging, space target imaging and luminous imaging',
        satellite11Resolution:'High score 03B pushbroom Satellite: better than 1m; high score 03C Video Star: better than 1.2m',
        satellite11Bounds:'High score 03B pushbroom Satellite: full color 450-700nm, blue 450-510nm, green 510-580nm, red 630-690nm, near infrared 770-895nm; high score 03C Video Satellite: Bayer color',
        satellite11Accuracy:'High score 03B pushbroom Satellite: better than 100m (ce90, dual star sensitive effective area); high score 03C Video Satellite: better than 300m (ce90, dual star sensitive effective area)',
        satellite11track:'Orbit type: sun synchronous orbit orbit altitude: 535km orbit semi major axis: 6913.14km orbit inclination: 97.54 ° defocus local time: 9:20am',
        satellite11range:'Better than 17 km (high score 03B pushbroom Satellite)',
        satellite11cover:'12000*5000（high score 03C Video Satellite）',
        satellite11imageTime:'High score 03B pushbroom Satellite: 300s; high score 03C Video Satellite: 120s',
        satellite11mass:'<42kg',
        satellite11life:'＞3 years',
        satellite11revisitPeriod:'Single star: 12 days; group star: 4 days (star point)',
        satellite11rocket:'Long March 11 carrier rocket',
        satellite11launchSite: 'The Yellow Sea of China',
        satellite11channel: 'Multi file can be set, with the maximum of 450mbps and the minimum of 37.5mbps',
    },

    //access
    badge: 'badge',
    dataIterator: {
        rowsPerPageText: 'Items per page:',
        rowsPerPageAll: 'All',
        pageText: '{0}-{1} of {2}',
        noResultsText: 'No matching records found',
        nextPage: 'Next page',
        prevPage: 'Previous page'
    },
    dataTable: {
        rowsPerPageText: 'Rows per page:'
    },
    noDataText: 'No data available',
    app: {
        title: 'Jilin-1 Data Direct-Access System',
        savedProduct: 'Imagery Archive',
        demand: 'Tasking Service',
        loginRemind: 'Please Login first',
        targetLibrary: 'Target Library',
        customizeTargetLibrary: 'My Places',
        aisTargetLibrary: 'AIS Target',
        comingSoon: 'Coming soon...',
        dataManagement: 'Data Management',
        myOrder: 'My Order',
        orbitalSimulation: 'Orbital Simulation',
        allSatellites: 'All Satellites',
        visibilityAnalysis: 'Visibility Analysis',
        feedback: 'Feedback',
        clickToLogin: 'Click To Login',
        submittedSuccessfully: 'Congratulations!',
        close: 'Close',
        warning1: 'Please enter title!',
        warning2: 'Please enter content!',
    },
    search: {
        main: {
        favorite: 'Fav.',
        measure: 'Meas.',
        exit: 'Exit',
        cancel: 'Cancel',
        chromeTip: 'For your better experience, it is recommended to use Chrome browser to visit this site',
        clickToDownload: 'Download',
        favoriteName: 'Name',
        add: 'Add',

        selectedArea: 'Selected area ',
        selectedPoint: 'Selected Coordinate ',
        selectedLine: 'Selected LineString ',
        selectedFile: 'Selected File ',
        selectedPoiCollection: 'Selected POI Collection',

        disabledInTargetMode: 'This feature is not available in TargetMode',
        geographicalRange: 'AOI',
        advancedCondition: 'Filters',
        search: 'Search',
        collapseResults: 'Collapse QueryList',
        expandResults: 'Expand QueryList',
        searching: 'Searching...',
        close: 'Close',
        sum1: 'Jilin-1 Constellation has',
        sum2: 'satellites currently.Imagery Archive',
        sum3: 'scenes.Total area',
        sum4: 'km²',
        sum5: 'Search result:Imagery Archive',
        sum6: 'scenes.Total area',
        sum7: 'km².',
        sum9: 'Image Archive',
        sum10: 'km².',
        viewDataCoverage: 'View Data Coverage',
        targetMode: 'Target Mode',
        targetModeOn: 'Target Mode Activated',
        targetModeInfo: 'Click anywhere in the search range to achieve a quick search of historical images at that point. The timeline and list show these search results.',
        reselect: 'Reselect',
        generalOptics: 'Optical Image',
        luminous: 'Shimmer Image',
        video: 'Video',
        multispectral: 'Multispectral',
        squareKilometer: 'km²',
        noResults: 'No Result',
        errorText1: 'Please select within the range',
        research: 'Reselect filters',
        gotoPrograming: 'Submit tasking'
        },
        measure: {
        distance: 'Distance',
        area: 'Area',
        distance2: 'Distance:',
        area2: 'Area:',
        delete: 'Delete',
        start: 'Start',
        },
        favorite: {
        selected: 'Selected：',
        favorites: ' items',
        delete: 'delete',
        point: 'Point',
        linestring: 'LineString',
        polygon: 'Area',
        file: 'File',
        search: 'Search',
        keyword: 'Search'
        },
        cropBuy:{
        selectTip:'Please select blocks',
        cropBuy: 'Crop Buy',
        selected: 'Selected ',
        areas: ' blocks, area ',
        buyNow: 'Buy Now'
        },
        rangeSelector: {
        confirm: 'OK',
        point: 'Point',
        rectangle: 'Rectangle',
        polygon: 'Polygon',
        linestring: 'LineString',
        pointTarget: 'Point',
        drawingArea: 'draw',
        regionalCoordinates: 'Coords',
        administrativeRegions: 'Region',
        uploadFiles: 'Upload',
        startDrawing: 'Click to start drawing',
        centerPoint: 'Center',
        leftUpLongitude: 'LeftUpLng',
        leftUpLatitude: 'LeftUpLat',
        rightDownLongitude: 'RightDownLng',
        rightDownLatitude: 'RightDownLat',
        centerLongitude: 'CenterLng',
        centerLatitude: 'CenterLat',
        centerLength: 'Length(Kilometer)',
        centerWidth: 'Width(Kilometer)',
        centerRadius: 'Radius(Kilometer)',
        china: 'China',
        world: 'World',
        province: 'Province',
        city: 'City',
        county: 'County',
        country: 'Country',
        reset: 'Reset',
        required: 'Required',
        illegal: 'Illegal',
        gt0: 'Above 0',
        degree: 'Degree',
        dms: 'DMS',
        longitude: 'Longitude',
        latitude: 'Latitude',
        d: 'Degree',
        m: 'Minute',
        s: 'Second',
        upload1: 'Click or drag file to upload',
        upload2: 'Support .kml .kmz',
        upload3: '.zip(Include .shp .prj)',
        selected: 'Selected:'
        },
        standardProduct: {
        JL101A: 'JL101A(0.72m)',
        JL1GF02AB: 'JL1GF02A/02B(0.75m)',
        JL1KF01A: 'JL1KF01A(0.75m)',
        JL103B: 'JL103B(0.92m)',
        JL10XB: 'JL104/05/06/07/08B(0.92m)',
        JL1GF03A: 'JL1GF03A(1m)',
        JL1GF03B: 'JL1GF03B series(1m)',
        JL1GF03C: 'JL1GF03C series(1m)',
        JL1GP0102: 'JL1GP01/02(5m)',
        confirm: 'OK',
        reset: 'Reset',
        type: 'Type',
        gsd: 'GSD',
        productId: 'ProductId',
        productType: 'Product Type',
        productBand: 'Product Band',
        satellite1: 'Satellites',
        satellite2: 'Satellites, Switch to Image GSD',
        imageGsd1: 'Image GSD',
        imageGsd2: 'Image GSD, Switch to Satellites',
        cloudPercent: 'Cloud Percent',
        rollSatelliteAngle: 'Roll Angle',
        startTime: 'Start Time',
        endTime: 'End Time'
        },
        standardResult: {
        generalOptics: 'OI',
        luminous: 'SI',
        video: 'VI',
        multispectral: 'MS',

        buyNow: 'Buy Now',
        addToCart: 'Add Cart',
        cropBuy: 'Crop Buy',
        cropBuyTip: 'This type of product does not support crop buy',

        targetMode: 'Point',
        bands: 'Bands',
        perpage: 'PerPage',
        years: 'Years',
        purchase: 'Purchase selected',
        targetModeTip: 'Click anywhere within the search range.',
        searching: 'Searching...',
        noResults: 'Sorry, there are no related search results under this category',
        hideThumbnail: 'Hide Thumbnail',
        showThumbnail: 'Show Thumbnail',
        detail: 'Detail',
        confirmLevel: 'Please confirm product level',
        standardProduct: 'Standard Product',
        orthogonalFusionProduct: 'Orthogonal Fusion Product',
        mosaicProduct: 'Mosaic Product',
        cancel:'Cancel',
        submit: 'Submit',
        jumpTip: 'Switch to confirm the order',
        close: 'Close',
        band: 'bands',
        all: 'All',
        allyears: 'Years: All',
        allbands: 'Bands: All',
        satellite: 'Satellite',
        gsd: 'GSD',
        imagingTime: 'Imaging Time',
        cloudPercent: 'Cloud',
        rollSatelliteAngle: 'Angle',
        noMoreResults: 'No more results',
        scrollOrClick: 'Click or scroll to the bottom to load more'
        },
        cart: {
        cart: 'Cart',
        total:'Total ',
        scenes:' scenes',
        selected:'Selected: ',
        delete:'Delete',
        purchase: 'Buy Selected',
        shp:'Export shp',
        deleteConfirm: 'Delete selected',
        confirm: 'Delete',
        cancel: 'Cancel',
        price: 'Price',
        totalPrice: 'Total: ',
        tip: 'The basic satellite data is charged according to the actual product area. The amount on this page is the standard product guide price. The actual sales price is based on the final price on the settlement page.',
        }
    },
    satelliteId:{
        'JL101A': 'Jilin-1GXA',
        'JL103B': 'Jilin-1SP03',
        'JL104B': 'Jilin-1SP04',
        'JL105B': 'Jilin-1SP05',
        'JL106B': 'Jilin-1SP06',
        'JL107B': 'Jilin-1SP07',
        'JL108B': 'Jilin-1SP08',
        'JL101C': 'Jilin-1GP01',
        'JL102C': 'Jilin-1GP02',
        'JL101D': 'Jilin-1GF03A',
        'JL101E': 'Jilin-1GF02A',
        'JL102E': 'Jilin-1GF02B',
        'JL101K': 'Jilin-1KF01A',
        'JL1GP01': 'Jilin-1GP01',
        'JL1GP02': 'Jilin-1GP02',
        'JL1GF03A': 'Jilin-1GF03A',
        'JL1GF02A': 'Jilin-1GF02A',
        'JL1GF02B': 'Jilin-1GF02B',
        'JL1KF01A': 'Jilin-1KF01A',
        'JL1GF03B01': 'Jilin-1GF03B01',
        'JL1GF03B02': 'Jilin-1GF03B02',
        'JL1GF03B03': 'Jilin-1GF03B03',
        'JL1GF03B04': 'Jilin-1GF03B04',
        'JL1GF03B05': 'Jilin-1GF03B05',
        'JL1GF03B06': 'Jilin-1GF03B06',
        'JL1GF03C01': 'Jilin-1GF03C01',
        'JL1GF03C02': 'Jilin-1GF03C02',
        'JL1GF03C03': 'Jilin-1GF03C03',
    },
    searchBar: {
        tip:'Search',
        snackbar:'Search location, coordinate, target library, product ID. Example: 22.9621, 113.9826, latitude first, comma separated',
        targetLibrary: 'Target Library',
        noResults: 'No Results',
        poiCollections:'POI Collections',
        all: 'All:',
        coordinate: 'Coordinate',
        productId: 'Product ID',
        lat: 'Latitude:',
        lng: 'Longitude:',
    },
    standardProductDetail: {
        select: 'Select Current',
        zoomIn: 'Click to zoom in',
        bands: 'Bands:',
        detail: 'Detail',
        generalOptics: 'Optical',
        luminous: 'Shimmer',
        video: 'Video',
        multispectral: 'Multispectral',
        productType: 'Type:',
        imagingDate: 'Date:',
        imagingTime: 'Time:',
        productArea: 'Area:',
        imageGsd: 'GSD:',
        cloudPercent:'Cloud:',
        solarElevation: 'Solar Elevation:',
        sensor: 'Sensor:',
        satelliteId: 'Satellite:',
        bandCount: 'Band Count:',
        rollSatelliteAngle: 'Roll:',
        centerCoordinate: 'Center Coordinate:',
        thumbnail: 'Thumbnail:',
        show: 'Show'
    },
    layerChanger: {
        layerChange:'Switch Basemap',
        title1: 'Blue Black',
        title2: 'TianDitu(Default)',
        title3: 'Google Map',
        title4: 'Google Satellite',
        title5: 'TianDitu Satellite'
    },
    demandConfirmation: {//TODO 需求确认页面，待改为英文
        jl1store: '吉林一号遥感商城',
        requirementName: '输入需求名称',
        requirementNamePlaceholder: '请输入需求名称',
        requirementNameInfo: '需求名称可便于您查找已创建订单',
        requirementNameTip:'不超过20个字符',
        confirmImageInformation:'确认影像信息',
        demandConfirmation: '需求确认',
        paymentReview: '支付审核',
        deliver:'交付',
        appraise:'评价',
        submitOrder: '订单提交',
        requirementNameVerify: ['需求名称不能为空！','需求名称不能超过20个字符！'],
        cutting: '裁剪',
        optional: '非必选项',
        uploadShpFile: '上传矢量文件',
        clickAndUpload: '点击上传',
        treatmentGrade: '处理等级',
        treatmentGradeExplain: '查看适用说明',
        treatmentGradeExplainTitle: '处理等级适用情形参考',
        treatmentGradeTip: '最多可选2种',
        treatmentGradeItemsOpenTip:['更多','收起'],
        treatmentGradeItems:['L1级传感器校正产品','L3C级系统几何校正融合产品','L3D级系统几何校正可视化产品','L1B级传感器校正反射率产品','L1B_PSH级传感器校正反射率融合产品','L1C级像素级融合产品','L2A级预正射产品','L2B级预正射反射率产品','L2B_PSH级预正射反射率产品融合产品','L2C级预正射融合产品','L2D级预正射可视化产品','L3A级系统几何校正产品','L3B级系统几何校正反射率产品','L3B_PSH级系统几何校正反射率融合产品',/* 'L5级镶嵌产品' */],
        treatmentGradeItemsExplain:['用于专业摄影测量及制图，方便用户可利用自己的处理算法进行后续处理；','用于用户进行专业的地物反演应用；','L1B级别产品的融合后产品，融合后影像实体为单个TIF；','适用于对空间分辨率及光谱分辨率同时具有较高需求的用户，方便用户进行后续处理；','方便用户快速将产品用于特征提取、分类、制图等实际应用中；','用于用户进行专业的地物反演应用；','L2B级别产品的融合后产品，融合后影像实体为单个TIF；','适用于对空间分辨率及光谱分辨率同时具有较高需求的用户；','可视化产品，适用于一般用户的快速查看及制图应用；','适用于对精度有更高需求的用户，方便用户快速将产品用于实际应用中；','适合于对精度有更高需求的用户，用户可将产品用于专业反演应用；','L3B级别产品的融合后产品，融合后影像实体为单个TIF；','适用于对空间分辨率及光谱分辨率同时具有较高需求的用户；','可视化产品，适用于一般用户的快速查看及制图应用；','适用于有大面积数据需求的用户，方便用户快速将产品用于特征提取、分类、制图等实际应用中。'],
        treatmentGradeRedTipShow:'提示：L1B、L1B_PSH、L2B、L2B_PSH、L3B、L3B_PSH级别数据拍摄完成5天后才能进行生产，如遇生产失败，请于拍摄5日后联系我们重新下生产单',
        mosaic:'镶嵌',
        mosaicItem:['不镶嵌','镶嵌(3谱8位)','镶嵌(4谱8位)','镶嵌(4谱16位)'],
        projectionMode:['投影方式','WGS84+UTM投影6°','WGS84+经纬投影','CGCS2000+高斯克吕格6°带','CGCS2000+高斯克吕格3°带'],
        projectionModeTip:['投影方式','（默认）','','1:25000-1:500000, 仅限光谱卫星','1:500-1:10000, 仅限亚米级卫星'],
    },
    orderConfirm: {
        rangeBrowsing: 'Range Browsing',
        cropBuy: 'Crop Buy',
        invoice: 'Invoice Info',
        invoiceTip: 'The taxpayer identification number must be filled in when issuing the invoice for the company to avoid reimbursement',
        invoiceEnable: 'Invoice',
        coupon: 'Coupon',
        couponEnable: 'Use Coupon',
        totalCredit: 'Total Credit',
        zhang: '',
        noCoupons: 'No Coupons',
        off: 'Off',
        over: 'Over ',
        validUntil: 'Valid Until ',
        total: 'Total：',
        cropping: 'Cropping',
        range: 'Range：',
        selectedCrop:'Currently selected crop area',
        orderMethod: 'Order Method:',
        only: 'Order crop area only',
        onlyTip: '*Only deliver cropped area results',
        all: 'Order all data and crop area',
        allTip1: '*Delivery of all standard product',
        allTip2: 'and cropped area results',
        price: 'Price：',
        confirm: 'Confirm',
        cropError: 'The file format is wrong or there is no intersection with the product, please check and re-upload',
        totalPrice: 'Total：',
        discount: 'Discount：',
        commodity: 'Commodity',
        order: 'Order',
        markdownCoupon: 'Markdown',
        discountCoupon: 'Discount',
        uploadedFile: 'Uploaded File',
        fullDelivery: 'Full Delivery',
        cropDelivery: 'Crop Delivery，area',
        orderDetail: 'Order Detail',
        noInvoice: 'No Invoice',
        makeUp: 'Make Up Invoice',
        show: 'Show',
        realPrice: 'Paid price：',
        none: 'None',
        orthorectification: 'Orthorectification',
        downgrade: 'Downgrade（16bits to 8bits）',
        enhance: 'Enhance',
        mosaic: 'Mosaic',
        allResolution: 'All resolution combination',
        sameResolution: 'Same resolution combination',

        confirmOrder: 'Confirm Order',
        purchaseData: 'Purchase',
        submitOrder: 'Submit Order',
        contectReview: 'Payment',
        download: 'Download',
        productId: 'Product Id',
        productProperties: 'Product Properties',
        productType: 'Product Type: ',
        productLevel: 'Product Level: Standard',
        sensor: 'sensor: ',
        satelliteId: 'Satellite: ',
        cloudPercent:'Cloud Percent: ',
        rollSatelliteAngle: 'Roll Satellite Angle: ',
        imageGsd: 'Image GSD: ',
        imagingTime: 'Imaging Time: ',
        tip1: 'Please scan the QR code / telephone / e-mail to contact us to assign the number of times, then submit the request',
        tip2: 'Mailto: ',
        tip3: 'Tel:',
        tip4: '',
        tip5: ' trial data service, ',
        tip6: ' archived data service total in the current account',
        total1: 'Total purchase ',
        total2: ' scenes',
        submit: 'Submit',
        myOrder: 'View my order',
        continue: 'Continue to retrieve',
        success: 'Your order has been submitted successfully',
        level: 'Level',
        standard: 'Standard',
        advanced: 'Advanced',
        handles: 'Handles',
        crop: 'Crop',
        cropTip:'For cropping please upload a zip containing four files: .shp, .dbf, .shx and .prj',
        remark: 'Comment',
        remarkTip: 'Please enter a comment',
        projection: 'Projection',
        pattern: 'Pattern',
        longitude: 'Center longitude',
        latitude: 'Center latitude',
        size: 'Size'
    },
    demandConfirm: {
        /*pended: 'Pended',
        producting: 'Producting',
        preparing: 'Preparing',
        ready: 'Ready',
        canceled: 'Canceled',
        orderInformation: 'Order Information',
        requirment: 'Imaging Requirment',
        deliveryRequirment: 'Delivery Requirment',
        a1:"Order number：",
        a2:"Create time：",
        a3:"Demand name：",
        a4:"Demand type：",
        a5:"Target type：",
        a6:"GSD：",
        a7:"Cloud percent：",
        a8:"Roll angle：",
        a9:"Longtitude：",
        a10:"Latitude：",
        a11:"Imaging mode：",
        a12:"Imaging duration：",
        a13:"Imaging time：",
        a14:"Remarks：",
        a15:"Product level：",
        a16:"Delivery time：",
        standardProduct: 'Standard Product',
        programmingPhotography: 'Programming Photography',
        startTime: 'Start time',
        endTime: 'End time',
        status: 'Status',
        loading: 'Loading',
        none: 'None',
        pointTarget: 'Point Target'*/
        title: 'Confirm Order Information',
        name: 'Name',
        priorityType: 'Service type',
        time: 'Time',
        imageMode: 'Mode',
        imageGeometry: 'Location',
        cloud: 'Cloud',
        rollSatelliteAngle: 'Roll Angle',
        processType: 'Level',
        area: 'Area',
        videoLength: 'Video',
        ProcessingDetail: 'Processing Detail',
        shadow: 'Projection',
        handles: 'Handle',
        pattern: 'Format',
        tailor: 'Tailor',
        remark: 'Remark',
        transitInquiry: 'Transit inquiry',
        invoiceInfo: 'Invoice information',
        invoiceTitle: 'The taxpayer`s identification number must be filled in when issuing the enterprise`s header invoice, so as not to affect the reimbursement',
        invoice: 'Invoicing',
        change: 'modify',
        coupon: 'coupon',
        useCoupon: 'Clip coupons',
        useCoupon1: 'Clip coupons，Common offset',
        useCoupon2: '￥：Clip coupons',
        useCoupon3: 'sheet',
        useCoupon4: 'full',
        useCoupon5: 'Valid until',
        noCoupon: 'No coupons',
        totalMoney: 'Total amount',
        discount: 'Discount',
        totalAmount: 'Total amount payable',
        submit: 'submit',
    },
    demand: {
        title1:'Fast Programming Services' ,
        title2:'At present, there are 16 satellites in jilin-1 constellation, which have the ability of revisiting anywhere in the world up to six times a day.',
        title3:'The available data types include sub meter level ordinary optical image, sub meter level night light image, sub meter level video image and multi spectral image with large and wide spectral segments.' ,
        title4:'Customized shooting mode according to your needs.',
        title: 'Image Tasking Information',
        searchPoiName:'Search point,lon&lat and target',
        minArea: 'Minimum starting area',
        selectArea: 'Area of selected area',
        selectPoint:'Select Point',
        closeMap:'Turn off map point selection',
        areaTargetDialog:'Regional target does not support online submission requirements at present',
        areaTargetDialog1:'Please scan the QR code on the left to contact online customer service or contact Changguang satellite marketing departmen',
        areaTargetDialog2:'Email：market@charmingglobe.com',
        areaTargetDialog3:'Phone：0431-86008580',
        requireName: 'Name',
        requireName1:'Please enter the name,Chinese or English',
        serviceType: 'Type',
        generalProgrammingServices:"General Programming",
        speedProgrammingServices:"Speed Programming",
        emergencyProgrammingServices:"Emergency Programming",
        imagingPosition:"Position",
        imagingPosition1:'Please input latitude and longitude, e.g.11.135, 12.356',
        mapSelectPoint:'Map point selection',
        transitInquiry:'Transit inquiry',
        timeTitle:'Under the normal programming, after submitting the demand, arrange the shooting data within 7-60 days, and deliver the data within 5 working days after shooting. After selecting the start time, the system will automatically select the end time',
        timeTitle1:'In the fast programming mode, take photos within 24 hours to 7 days after submitting the demand, and deliver the data within 3 working days after shooting. After selecting the start time, the system will automatically select the end time',
        timeTitle2:'In the emergency programming mode, select the specified shooting time, no more than 24 hours from the start of the injection to the delivery of data',
        imagingTime: 'Time',
        drawnArea:'Drawn area',
        coordinateAreaSet:'Coordinate Area Set',
        AreaSelect:'Administrative Region Selected',
        FileUpload:'Uploaded file',
        noFileUploda:'No files available, No range',
        PositionSee:'Location Preview',
        Reselect:'Reselect',
        productLevel: 'Product Level',
        deliveryTime: 'Deliver Time',
        resolutionRequirement: 'Resolution',
        imagingMode: 'Mode',
        imagingDuration: 'Duration',
        rollAngle: 'Roll Angle',
        cloudPercent: 'Cloud',
        processingLevel: 'Processing',
        projection:'Projection',
        process:'Process',
        format:'Format',
        tailor:'Tailor',
        tailor1:'To crop, upload KML KMZ or zip containing SHP and Prj',
        CenterLongitude:'Longitude',
        CenterLatitude:'Latitude',
        selectSize:'Please select size',
        orthographic:'Orthographic',
        drop:'Drop(16 bits to 8 bits)',
        mosaic:'Mosaic',
        enhance:'Enhance',
        fullResolution:'Full resolution',
        sameResolution:'Same Resolution',
        remarks: 'Remark',
        remarks1:'Please enter notes',
        targetType: 'Target Type',
        pointTarget: 'Point',
        areaTarget: 'Area',
        longtitude: 'Lon',
        latitude:  'Lat',
        switch: 'Switch',
        reset: 'Reset',
        transit: 'Passby query',
        targetLibrary: 'Add this requirement to target library',
        targetName: 'Target Name',
        submit: 'Submit',
        tip:'Search by POI or my places',
        operationPrompt: 'Operation Hint',
        confirm: 'Confirm',
        return: 'Return',
        queryTime: 'Query Time',
        satellite: 'Satellite',
        search: 'Search',
        noResults: 'Sorry,there are no eligible query results.',
        searching: 'Searching...',
        close: 'Close',
        standardProduct: 'Standard Product',
        orthogonalFusionProduct: 'Orthogonal',
        after24: '24 hours after acquisition',
        after48: '48 hours after acquisition',
        after72: '72 hours after acquisition',
        push: 'Pushroom',
        gaze: 'Gaze',
        luminous: 'Shimmer',
        stereoscopic: 'Stereoscopic',
        transitSatellite: 'Satellite',
        transitTableStartTime: 'Start Time',
        transitTableEndTime: 'End Time',
        transitTableSideAngle: 'Roll Angle',
        transitTableSunAngle: 'Solar Elevation',
        alert1: 'The latitude and longitude is not entered completely.',
        alert2: 'The latitude and longitude is out of range(longitude range -180°~180°;latitude range -90°~90°)',
        alert3: 'Please fill in the request name.',
        alert4: 'The end time should be after the start time.',
        alert5: 'Please fill in target point name.',
        alert6: 'The target point name already exists, please modify and submit!',
        submiting: 'Submitting, please wait',
        success: 'The request was submitted successfully!',
        alert7: 'Please select at least one satellite for transit check',
        alert8: 'The transit query end time should be after the start time, please reselect the time range',
        alert9: 'The transit time span can be up to three days. Please reselect the time range.',
        requestList:'List of current requirements',
        requType:'Service type',
        imageTime:'Time',
        imageMode:'Imaging mode',
        imgagePosition:'Image location',
        cloud:'cloud',
        rog:'Roll Angle',
        proLevel:'Processing',
        imagePrice:'Price',
        imagePrice1:'Expenses',
        productArea:'Product area',
        videoLong:'Video duration',
        TotalAmountPay:'Total Money',
        BuyNow:'Buy now',
        CustomerService:'Customer',
        BusinessAffairs:'Business',
        email:'Email',
        snackbarInfo:'Illegal entry of latitude and longitude of coordinate point',
        snackbarInfo1:'Minimum starting area is 25km²',
        snackbarInfo2:'Please enter the requirement name！',
        snackbarInfo3:'The latitude input is illegal. Please enter a number between - 90 and 90',
        snackbarInfo4:'The longitude input is illegal. Please enter a number between - 90 and 90',
        snackbarInfo5:'Please enter the latitude of the center point',
        snackbarInfo6:'Please enter the longitude of the center point',
        title11:"In reference to weather forecast and programming conflicts\n" +
            "\n" +
            "Next, according to the customer's requirements, normal queue processing,\n" +
            "\n" +
            "Arrange shooting data within 7-60 days, after shooting\n" +
            "\n" +
            "Data delivered within 5 working days, normal\n" +
            "\n" +
            "Programming services.",
        title21:"24 to 7 days after order submission,\n" +
            "\n" +
            "And delivered within 3 working days after shooting\n" +
            "\n" +
            "Data or specified time specified area non track\n" +
            "\n" +
            "Data in shooting task, programming for high speed\n" +
            "\n" +
            "Services. Fast programming service cannot filter days\n" +
            "\n" +
            "The influence of Qi factor.",
        title31:"Provide the fastest programming response time, in the\n" +
            "\n" +
            "Request before 15:00 on the day of order delivery,\n" +
            "\n" +
            "No more than 24 from the start of note up to data delivery\n" +
            "\n" +
            "Hours for emergency programming. Emergency response\n" +
            "\n" +
            "Service can't filter the influence of weather factors.",
        title41:"Ordinary optical image with resolution better than 1m\n" +
            "\n" +
            "L1 panchromatic + multispectral push scan data, minimum\n" +
            "\n" +
            "Starting area: 10km × 10km",
        title5:"Video image is L1B with resolution better than 1m\n" +
            "\n" +
            "Satellite video, each satellite video defaults to\n" +
            "\n" +
            "30 s long staring video in designated area, area\n" +
            "\n" +
            "The area is 11km × 4.5km",
        title6:"The resolution of night light image is better than 1 m, the minimum\n" +
            "\n" +
            "Starting area: 11km × 4.5km",
        title7:"The multispectral image has a resolution of 5m and a spectral segment of 20\n" +
            "\n" +
            "Visible near infrared data, minimum binding surface\n" +
            "\n" +
            "50km × 50km",
        title8:"The standard product is the default data product level:\n" +
            "\n" +
            "Radiation correction, sensor and\n" +
            "\n" +
            "After the error correction and optimization caused by the satellite platform\n" +
            "\n" +
            "The image level of.",
        title9:"Advanced processing products are\n" +
            "\n" +
            "Advanced products of inlay processing, you can directly\n" +
            "\n" +
            "Use the advanced processing default process. If anything\n" +
            "\n" +
            "Specific requirements can be selected from the following options.",
        lat:'longitude',
        lng: 'latitude',
        startTime:'startTime',
        endTime: 'endTime',
        sateResource: 'Satellite ',
        SideswayAngle: 'Sidesway angle',
        sunEa: 'Solar altitude angle',
        cloud1:'cloud',
        JL101A: 'Jilin No.1 Optical A Star',
        JL103B: 'Jilin No.1 video 03 stars',
        JL104B: 'Jilin No.1 video 04 stars',
        JL105B: 'Jilin No.1 video 05 stars',
        JL106B: 'Jilin No.1 video 06 stars',
        JL107B: 'Jilin No.1 video 07 stars',
        JL108B: 'Jilin No.1 video 08 stars',
        JL101C: 'Jilin No.1 Spectrum 01 Star',
        JL102C: 'Jilin No.1 Spectrum 02 Star',
        JL101E: 'Jilin One High Score 02A Star',
        JL102E: 'Jilin One High Score 02B Star',
        JL101K: 'Jilin No.1 Wide Format 01 Star',
        JL101D: 'Jilin One High Score 03A Star',
        error1: 'Longitude or latitude is not completed, please fill in the complete query',
        error2: 'Latitude and longitude input range does not meet specifications',
        error3: 'Satellite resources cannot be empty',
        error4: 'Time range cannot be empty',
        loading1:'Loading....',
        noData: 'No Data',
    },
    orders:{
        generalProgrammingServices:"General programming services",
        speedProgrammingServices:"Speed programming services",
        emergencyProgrammingServices:"Emergency programming services",
        close: 'Close',
        productDetail: 'Product Detail',
        detail: 'Detail',
        loading: 'Loading',
        cancelOrder: 'Cancel Order',
        cancelOrderConfirm: 'Confirm Cancel the Order',
        confirm: 'Confirm',
        cancel: 'Cancel',
        savedProductOrder: 'Saved Product Order',
        programmingPhotographyOrder: 'Programming Photography Order',
        allOrders: 'All',
        pending: 'ToPaid',
        pended: 'Pended',
        preparing: 'Preparing',
        paid: 'Paid',
        canceled: 'Canceled',
        pointTargetOrders: 'Point Target Orders',
        areaTargetOrders: 'Area Target Orders',
        requireName: 'Require Name:',
        dataReady: 'Data Ready',
        view: 'View',
        player: 'Player',
        searchTip1: 'Enter the productID or orderNumber to search',
        searchTip2: 'Enter the requirementName or orderNumber to search',
        search: 'Search',
        generalOptics: 'General Optics',
        luminous: 'Luminous',
        video: 'Video',
        multispectral: 'Multispectral',
        all: 'All',
        standardProduct: 'Standard Product',
        orthogonalFusionProduct: 'Orthogonal Fusion Product',
        mosaicProduct: 'Mosaic Product',
        a1: 'Order number：',
        a2:"Request time：",
        a3:"Demand name：",
        a4:"Imaging mode：",
        a5:"GSD：",
        a6:"Coordinate：",
        a7:"Imaging time：",
        a8:"sensor：",
        a9:"Satellite：",
        a10:"Cloud percent：",
        a11:"Roll angle：",
        a12:"Product type：",
        a13:"Product level：",
        a14:"Trial",
        a15:"Saved Product",
        a16:"Programming",
        a17:"Source:",
        a18:"Projection：",
        a19:"Format：",
        a20:"Manage：",
        a21:"Tailor：",
        a22:"Remark：",
        a23:"longitude：",
        a24:"latitude：",
        a25:"size：",
        a26:"Service Type：",
        a27:"Amount： ",
        scene: 'scene',
        total: 'Total of your account',
        trialPermission: 'trial permission，used',
        savedProductPermission: 'saved product permission，used',
        programmingPhotographyPermission: 'programming photography permission，used',
        success: 'Order cancelled successfully',
        failed: 'Order cancelled failed',
        push: 'Push',
        gaze: 'Gaze',
        stereoscopic: 'Stereoscopic',
    },
    invoiceDialog:{
        title: 'Ensure that the invoice information provided is consistent with the registration information reserved in the tax authorities',
        type: 'Invoice type',
        comInvoice: 'VAT general invoice',
        specialInvoice: 'VAT special invoice',
        companyName: 'CompanyName',
        enterCompany: 'Enter company name',
        code: 'Taxpayer iden',
        code1: 'Taxpayer identification number',
        enterCode: 'Enter taxpayer identification',
        companyAdress: 'Company addr',
        companyAdress1: 'Company address',
        enterAdress: 'Enter company address',
        phone: 'work telephone',
        enterPhone: 'Enter work telephone',
        bank: 'Deposit bank',
        enterBank: 'Enter bank',
        bankAccount: 'Bank Account',
        enterBankAccount: 'Enter bank Account',
        isDefaultInvoice: 'Set as default header',
        nextStep: 'Next step',
        cancel: 'cancel',
        recipientName: 'Recipient\'s name',
        enterName: 'Enter Recipient\'s name',
        recipientPhone: 'Recipient mobile',
        enterRecipientPhone: 'Enter Recipient mobile',
        enterRecipientPhone1: '+86 (Chinese Mainland）',
        recipientAdress: 'Recipient\'s addr',
        addressProvince: 'Select province',
        addressCity: 'Select city',
        addressCounty: 'Select area',
        addressDetail: 'Detailed addr',
        enteraddressDetail: 'Please enter the detailed address',
        isDefaultInvoice1: 'Set as default receiving address',
        sure: 'confirm',
        close: 'close',
        errorPhone: 'Wrong format of mobile number',
        selectAdress: 'Please select a province',
    },
    //新增
    targetLibrary: {
        traget: 'TargetLibrary',
        keywordSearch: 'Keyword search',
        btn: '+ New target point',
        targetPointName: 'Target Point Name',
        lat: 'longitude',
        lon: 'latitude',
        searchImage: 'Check archive image',
        submitProgram: 'submit ProgramOrder',
        delete: 'delete',
        noData: 'No Data',
        newBuild: 'New target point',
        name: 'Name',
        nameLength: 'Up to ten Chinese',
        transform: 'Transform',
        reset: 'Reset',
        submit: 'Submit',
        alert: 'Operation tips',
        close: 'Close',
        deleteAlert: 'Delete prompt',
        deleteConfirm: 'confirm deletion',
        cancel: 'Cancel',

    },
    payment:{
        title: 'Successfully, please pay as soon as possible！',
        paid: 'Actual paid',
        payWay: 'Payment method',
        wechat: 'Wechat payment',
        duiGong: 'Corporate transfer',
        alipay: 'Alipay',
        comfirmPay: 'Confirm pay',
        OfflinePayment: 'Offline payment',
        reminder: 'Tips',
        alert: '1、The financial department will review and check the account within 3 working days. If the account is received, the production of your order will be scheduled within 1 hour. Due to the bank\'s processing time, payment to the account may be delayed。',
        alert1: '2、If you have any problem in the process of offline remittance, you can contact us at any time',
        customer: 'Customer',
        account: 'Pay to Changguang Satellite account ',
        account1: 'Transfer channels',
        account2: 'Bank counter transfer, online banking',
        account3: 'Name of payee',
        account4: 'Changguang Satellite Technology Co., Ltd',
        account5: 'Collection account',
        account6: 'Receiving bank',
        account7: 'Changchun Chaoyang sub Construction branch',
        account8: 'Remittance remarks',
        account9: 'Direct-Access System Order+account mobile',
        account10: 'Please keep the remittance slip properly',
        account11: 'Submit remittance information',
        account12: 'After successful payment contact',
        account13: 'Submit information',
        account14: 'Remittance result feedback',
        account15: 'confirm the payment operation,',
        account16: 'Order List',
        account17: 'that view production progress ',
        ortherWay: 'Choose another payment method',
        scan: 'Please scan the code to pay',
        price: 'money',
        scan1: 'Please use wechat scan to scan QR code for payment',
        bottom: 'Changguang Satellite Technology Co., Ltd. 2020',
        bottom1: 'Jicpb no.15001825-1',
        bottom2: '1299 Mingxi Road, Beihu science and Technology Development Zone, Changchun City, Jilin Province',
        call: 'contact us',
        phone1:'phone',
        market:'market',
        close: 'close',
        fail: 'Payment failure',
        back: 'Return to order',
        phone: 'customer service',
    },
    programPhotoInfo:{
        myOrder: 'My Order',
        detail: 'Detail',
        OrderNum: 'OrderNum',
        status: 'status',
        money: 'Money',
        createTime: 'Time',
        payTime: 'payTime',
        resource: 'Resource',
        name: 'Name',
        type: 'Type',
        imageTime: 'imageTime',
        imageMode: 'Mode',
        imageLocation: 'Location',
        cloud: 'Cloud',
        rollSatelliteAngle: 'Roll Angle',
        level: 'Level',
        area: 'Area',
        processDetail: 'Process Detail',
        shadow: 'Projection',
        process: 'Handle',
        pattern: 'Format',
        tailor: 'Tailor',
        download: 'Download',
        remark: 'Remark',
        transitInquiry: 'Transit Inquiry',
        No: 'NO',
        No1: 'imaging',
        see: 'View',
        link: 'Download',
        invoiceInfo: 'Invoice Information',
        noInvoice: 'Invoice not applied',
        reissueInvoice: 'Complement invoicing',
        noInvoice1: 'No coupons at the moment, a total of 0 yuan is used: 0 coupons are used',
        discount: 'Coupon',
        useInvoice: 'Use coupons',
        useInvoice1: '￥：Use coupons',
        useInvoice2: 'sheet',
        totalMoney: 'Total amount',
        discount1: 'Discount',
        totalMoney1: 'Total amount payable',
    }
}
